(window.theme = window.theme || {}),
    (window.slate = window.slate || {}),
    (window.lazySizesConfig = window.lazySizesConfig || {}),
    (lazySizesConfig.expFactor = 4),
    Handlebars.registerHelper("contains", function (a, b, c) {
        return (a = Handlebars.escapeExpression(a)), (b = Handlebars.escapeExpression(b)), b.indexOf(a) > -1 ? c.fn(this) : c.inverse(this);
    }),
    (function (a) {
        var a = (jQuery = a);
        (slate.utils = {
            defaultTo: function (a, b) {
                return null == a || a != a ? b : a;
            },
        }),
            (slate.a11y = {
                trapFocus: function (b) {
                    var c = b.namespace ? "focusin." + b.namespace : "focusin";
                    b.$elementToFocus || (b.$elementToFocus = b.$container),
                        b.$container.attr("tabindex", "-1"),
                        b.$elementToFocus.focus(),
                        a(document).off("focusin"),
                        a(document).on(c, function (a) {
                            b.$container[0] === a.target || b.$container.has(a.target).length || b.$container.focus();
                        });
                },
                removeTrapFocus: function (b) {
                    var c = b.namespace ? "focusin." + b.namespace : "focusin";
                    b.$container && b.$container.length && b.$container.removeAttr("tabindex"), a(document).off(c);
                },
                lockMobileScrolling: function (d, b) {
                    if (b) var c = b;
                    else var c = a(document.documentElement).add("body");
                    c.on("touchmove" + d, function () {
                        return !1;
                    });
                },
                unlockMobileScrolling: function (d, b) {
                    if (b) var c = b;
                    else var c = a(document.documentElement).add("body");
                    c.off(d);
                },
            }),
            (theme.Sections = function () {
                (this.constructors = {}),
                    (this.instances = []),
                    a(document)
                        .on("shopify:section:load", this._onSectionLoad.bind(this))
                        .on("shopify:section:unload", this._onSectionUnload.bind(this))
                        .on("shopify:section:select", this._onSelect.bind(this))
                        .on("shopify:section:deselect", this._onDeselect.bind(this))
                        .on("shopify:block:select", this._onBlockSelect.bind(this))
                        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = a.extend({}, theme.Sections.prototype, {
                createInstance: function (b, c) {
                    var d = a(b),
                        f = d.attr("data-section-id"),
                        e = d.attr("data-section-type");
                    if (void 0 !== (c = c || this.constructors[e])) {
                        var g = a.extend(new c(b), { id: f, type: e, container: b });
                        this.instances.push(g);
                    }
                },
                _onSectionLoad: function (b, c, f) {
                    AOS && AOS.refreshHard();
                    var e = c || a("[data-section-id]", b.target)[0];
                    if (e) {
                        this.createInstance(e);
                        var d = c ? f : this._findInstance(b.detail.sectionId);
                        c || this._loadSubSections(), d && "function" == typeof d.onLoad && d.onLoad(b);
                    }
                },
                _loadSubSections: function () {
                    AOS && AOS.refreshHard(),
                        a("[data-subsection]").each(
                            function (c, b) {
                                this._onSectionLoad(null, b, a(b).data("section-id"));
                            }.bind(this)
                        );
                },
                _onSectionUnload: function (b) {
                    var a = this._removeInstance(b.detail.sectionId);
                    a && "function" == typeof a.onUnload && a.onUnload(b);
                },
                _onSelect: function (b) {
                    var a = this._findInstance(b.detail.sectionId);
                    a && "function" == typeof a.onSelect && a.onSelect(b);
                },
                _onDeselect: function (b) {
                    var a = this._findInstance(b.detail.sectionId);
                    a && "function" == typeof a.onDeselect && a.onDeselect(b);
                },
                _onBlockSelect: function (b) {
                    var a = this._findInstance(b.detail.sectionId);
                    a && "function" == typeof a.onBlockSelect && a.onBlockSelect(b);
                },
                _onBlockDeselect: function (b) {
                    var a = this._findInstance(b.detail.sectionId);
                    a && "function" == typeof a.onBlockDeselect && a.onBlockDeselect(b);
                },
                _findInstance: function (b) {
                    for (var a = 0; a < this.instances.length; a++) if (this.instances[a].id === b) return this.instances[a];
                },
                _removeInstance: function (c) {
                    for (var b, a = this.instances.length; a--; )
                        if (this.instances[a].id === c) {
                            (b = this.instances[a]), this.instances.splice(a, 1);
                            break;
                        }
                    return b;
                },
                register: function (b, c) {
                    (this.constructors[b] = c),
                        a("[data-section-type=" + b + "]").each(
                            function (b, a) {
                                this.createInstance(a, c);
                            }.bind(this)
                        );
                },
            })),
            (theme.Currency = {
                formatMoney: function (a, f) {
                    "string" == typeof a && (a = a.replace(".", ""));
                    var b = "",
                        d = /\{\{\s*(\w+)\s*\}\}/,
                        e = f || "$";
                    function c(a, b, c, d) {
                        if (((b = slate.utils.defaultTo(b, 2)), (c = slate.utils.defaultTo(c, ",")), (d = slate.utils.defaultTo(d, ".")), isNaN(a) || null == a)) return 0;
                        var e = (a = (a / 100).toFixed(b)).split("."),
                            f = e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c),
                            g = e[1] ? d + e[1] : "";
                        return f + g;
                    }
                    switch (e.match(d)[1]) {
                        case "amount":
                            b = c(a, 2);
                            break;
                        case "amount_no_decimals":
                            b = c(a, 0);
                            break;
                        case "amount_with_comma_separator":
                            b = c(a, 2, ".", ",");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            b = c(a, 0, ".", ",");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            b = c(a, 0, " ");
                    }
                    return e.replace(d, b);
                },
            }),
            (theme.Images = {
                imageSize: function (a) {
                    if (!a) return "620x";
                    var b = a.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                    return null !== b ? b[1] : null;
                },
                getSizedImageUrl: function (a, b) {
                    if (null == b) return a;
                    if ("master" === b) return this.removeProtocol(a);
                    var c = a.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (null != c) {
                        var d = a.split(c[0]),
                            e = c[0];
                        return this.removeProtocol(d[0] + "_" + b + e);
                    }
                    return null;
                },
                removeProtocol: function (a) {
                    return a.replace(/http(s)?:/, "");
                },
            }),
            (slate.Variants = (function () {
                function b(b) {
                    (this.$container = b.$container),
                        (this.variants = b.variants),
                        (this.singleOptionSelector = b.singleOptionSelector),
                        (this.originalSelectorId = b.originalSelectorId),
                        (this.enableHistoryState = b.enableHistoryState),
                        (this.currentVariant = this._getVariantFromOptions()),
                        a(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        _getCurrentOptions: function () {
                            var b = a.map(a(this.singleOptionSelector, this.$container), function (e) {
                                var b = a(e),
                                    d = b.attr("type"),
                                    c = {};
                                return "radio" !== d && "checkbox" !== d ? ((c.value = b.val()), (c.index = b.data("index")), c) : !!b[0].checked && ((c.value = b.val()), (c.index = b.data("index")), c);
                            });
                            return this._compact(b);
                        },
                        _getVariantFromOptions: function () {
                            var c = this._getCurrentOptions(),
                                a = this.variants,
                                b = !1;
                            return (
                                a.forEach(function (a) {
                                    var d = !0;
                                    a.options,
                                        c.forEach(function (b) {
                                            d && (d = a[b.index] === b.value);
                                        }),
                                        d && (b = a);
                                }),
                                b || null
                            );
                        },
                        _onSelectChange: function () {
                            var a = this._getVariantFromOptions();
                            this.$container.trigger({ type: "variantChange", variant: a }),
                                a && (this._updateMasterSelect(a), this._updateImages(a), this._updatePrice(a), this._updateSKU(a), (this.currentVariant = a), this.enableHistoryState && this._updateHistoryState(a));
                        },
                        _updateImages: function (a) {
                            var b = a.featured_image || {},
                                c = this.currentVariant.featured_image || {};
                            a.featured_image && b.src !== c.src && this.$container.trigger({ type: "variantImageChange", variant: a });
                        },
                        _updatePrice: function (a) {
                            (a.price !== this.currentVariant.price || a.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({ type: "variantPriceChange", variant: a });
                        },
                        _updateSKU: function (a) {
                            a.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: a });
                        },
                        _updateHistoryState: function (a) {
                            if (history.replaceState && a) {
                                var b = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + a.id;
                                window.history.replaceState({ path: b }, "", b);
                            }
                        },
                        _updateMasterSelect: function (b) {
                            a(this.originalSelectorId, this.$container).val(b.id);
                        },
                        _compact: function (a) {
                            for (var b = -1, e = null == a ? 0 : a.length, f = 0, c = []; ++b < e; ) {
                                var d = a[b];
                                d && (c[f++] = d);
                            }
                            return c;
                        },
                    })),
                    b
                );
            })()),
            (slate.rte = {
                init: function () {
                    slate.rte.wrapTable(), slate.rte.wrapVideo(), slate.rte.imageLinks();
                },
                wrapTable: function () {
                    a(".rte table").wrap('<div class="table-wrapper"></div>');
                },
                wrapVideo: function () {
                    var b = a('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                        c = b.add("iframe#admin_bar_iframe");
                    b.each(function () {
                        a(this).parents(".video-wrapper").length || a(this).wrap('<div class="video-wrapper"></div>');
                    }),
                        c.each(function () {
                            this.src = this.src;
                        });
                },
                imageLinks: function () {
                    a(".rte a img").parent().addClass("rte__image");
                },
            }),
            (theme.Modals = (function () {
                function b(b, c, d) {
                    if (((this.id = b), (this.$modal = a("#" + b)), !this.$modal.length)) return !1;
                    (this.nodes = { $parent: a("html").add("body"), $modalContent: this.$modal.find(".modal__inner") }),
                        (this.config = a.extend(
                            {
                                close: ".js-modal-close",
                                open: ".js-modal-open-" + c,
                                openClass: "modal--is-active",
                                closingClass: "modal--is-closing",
                                bodyOpenClass: "modal-open",
                                bodyOpenSolidClass: "modal-open--solid",
                                bodyClosingClass: "modal-closing",
                                closeOffContentClick: !0,
                            },
                            d
                        )),
                        (this.modalIsOpen = !1),
                        (this.$focusOnOpen = this.config.focusOnOpen ? a(this.config.focusOnOpen) : this.$modal),
                        (this.isSolid = this.config.solid),
                        this.init();
                }
                return (
                    (b.prototype.init = function () {
                        a(this.config.open).attr("aria-expanded", "false"),
                            a(this.config.open).on("click", this.open.bind(this)),
                            this.$modal.find(this.config.close).on("click", this.close.bind(this)),
                            a("body").on(
                                "drawerOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    }),
                    (b.prototype.open = function (b) {
                        var c = !1;
                        this.modalIsOpen ||
                            (b ? b.preventDefault() : (c = !0),
                            b && b.stopPropagation && (b.stopPropagation(), (this.$activeSource = a(b.currentTarget))),
                            this.modalIsOpen && !c && this.close(),
                            this.$modal.prepareTransition().addClass(this.config.openClass),
                            this.nodes.$parent.addClass(this.config.bodyOpenClass),
                            this.isSolid && this.nodes.$parent.addClass(this.config.bodyOpenSolidClass),
                            (this.modalIsOpen = !0),
                            slate.a11y.trapFocus({ $container: this.$modal, $elementToFocus: this.$focusOnOpen, namespace: "modal_focus" }),
                            this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),this.$activeSource.addClass("aria-expanded"),
                            a("body").trigger("modalOpen." + this.id),
                            this.bindEvents());
                    }),
                    (b.prototype.close = function () {
                        if (this.modalIsOpen) {
                            a(document.activeElement).trigger("blur"),
                                this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass),
                                this.nodes.$parent.removeClass(this.config.bodyOpenClass),
                                this.nodes.$parent.addClass(this.config.bodyClosingClass);
                            var b = this;
                            window.setTimeout(function () {
                                b.nodes.$parent.removeClass(b.config.bodyClosingClass), b.$modal.removeClass(b.config.closingClass);
                            }, 500),
                                this.isSolid && this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass),
                                (this.modalIsOpen = !1),
                                slate.a11y.removeTrapFocus({ $container: this.$modal, namespace: "modal_focus" }),
                                this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(),
                                a("body").trigger("modalClose." + this.id),
                                this.unbindEvents();
                        }
                    }),
                    (b.prototype.bindEvents = function () {
                        this.nodes.$parent.on(
                            "keyup.modal",
                            function (a) {
                                27 === a.keyCode && this.close();
                            }.bind(this)
                        ),
                            this.config.closeOffContentClick &&
                                (this.$modal.on("click.modal", this.close.bind(this)),
                                this.nodes.$modalContent.on("click.modal", function (a) {
                                    a.stopImmediatePropagation();
                                }));
                    }),
                    (b.prototype.unbindEvents = function () {
                        this.nodes.$parent.off(".modal"), this.config.closeOffContentClick && (this.$modal.off(".modal"), this.nodes.$modalContent.off(".modal"));
                    }),
                    b
                );
            })()),
            (theme.Drawers = (function () {
                function b(b, c) {
                    if (
                        ((this.config = { id: b, close: ".js-drawer-close", open: ".js-drawer-open-" + c, openClass: "js-drawer-open", closingClass: "js-drawer-closing", activeDrawer: "drawer--is-open", namespace: ".drawer-" + c }),
                        (this.$nodes = { parent: a(document.documentElement).add("body"), page: a("#MainContent") }),
                        (this.$drawer = a("#" + b)),
                        !this.$drawer.length)
                    )
                        return !1;
                    (this.isOpen = !1), this.init();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        init: function () {
                            var b = a(this.config.open);
                            b.attr("aria-expanded", "false"), b.on("click", this.open.bind(this)), this.$drawer.find(this.config.close).on("click", this.close.bind(this));
                        },
                        open: function (b) {
                            b && b.preventDefault(),
                                this.isOpen ||
                                    (b && b.stopPropagation && (b.stopPropagation(), (this.$activeSource = a(b.currentTarget))),
                                    this.$drawer.prepareTransition().addClass(this.config.activeDrawer),
                                    this.$nodes.parent.addClass(this.config.openClass).addClass(this.config.id),
                                    (this.isOpen = !0),
                                    slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                                    a("body").trigger("drawerOpen." + this.config.id),                      
                                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                                    this.bindEvents());
                        },
                        close: function () {
                            if (this.isOpen) {
                                a(document.activeElement).trigger("blur"),
                                    this.$drawer.prepareTransition().removeClass(this.config.activeDrawer),
                                    this.$nodes.parent.removeClass(this.config.openClass).removeClass(this.config.id),
                                    this.$nodes.parent.addClass(this.config.closingClass);
                                var b = this;
                                window.setTimeout(function () {
                                    b.$nodes.parent.removeClass(b.config.closingClass);
                                }, 500),
                                    (this.isOpen = !1),
                                    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
                                    this.unbindEvents();
                            }
                        },
                        bindEvents: function () {
                            slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page),
                                this.$nodes.page.on(
                                    "click" + this.config.namespace,
                                    function () {
                                        return this.close(), !1;
                                    }.bind(this)
                                ),
                                this.$nodes.parent.on(
                                    "keyup" + this.config.namespace,
                                    function (a) {
                                        27 === a.keyCode && this.close();
                                    }.bind(this)
                                );
                        },
                        unbindEvents: function () {
                            slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.parent.off(this.config.namespace), this.$nodes.page.off(this.config.namespace);
                        },
                    })),
                    b
                );
            })()),
            (theme.cart = {
                getCart: function () {
                    return a.getJSON("/cart.js");
                },
                changeItem: function (a, b) {
                    return this._updateCart({ type: "POST", url: "/cart/change.js", data: "quantity=" + b + "&id=" + a, dataType: "json" });
                },
                addItemFromForm: function (a) {
                    return this._updateCart({ type: "POST", url: "/cart/add.js", data: a, dataType: "json" });
                },
                _updateCart: function (b) {
                    return a.ajax(b).then(
                        function (a) {
                            return a;
                        }.bind(this)
                    );
                },
                updateNote: function (b) {
                    var c = { type: "POST", url: "/cart/update.js", data: "note=" + theme.cart.attributeToString(b), dataType: "json", success: function (a) {}, error: function (a, b) {} };
                    a.ajax(c);
                },
                attributeToString: function (b) {
                    return "string" != typeof b && "undefined" == (b += "") && (b = ""), a.trim(b);
                },
            }),
            a(function () {
                a("body").on("click", ".cart__checkout", function () {
                    a(this).addClass("btn--loading");
                }),
                    a("body").on("change", 'textarea[name="note"]', function () {
                        var b = a(this).val();
                        theme.cart.updateNote(b);
                    }),
                    a("body").on("click", ".cart__checkout--ajax", function (b) {
                        if (!a("#CartAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), a(this).removeClass("btn--loading"), !1;
                    }),
                    a("body").on("click", ".cart__checkout--page", function (b) {
                        if (!a("#CartPageAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), a(this).removeClass("btn--loading"), !1;
                    });
            }),
            (theme.QtySelector = (function () {
                var c = { input: ".js-qty__num", plus: ".js-qty__adjust--plus", minus: ".js-qty__adjust--minus" };
                function b(b, d) {
                    (this.$wrapper = b), (this.$input = b.find(c.input)), (this.$plus = b.find(c.plus)), (this.$minus = b.find(c.minus)), (this.minValue = this.$input.attr("min") || 1);
                    var e = { namespace: null, key: this.$input.data("id") };
                    (this.options = a.extend(e, d)), this.initEventListeners();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        initEventListeners: function () {
                            this.$plus.on(
                                "click",
                                function () {
                                    var a = this.validateQty(this.$input.val());
                                    this.addQty(a);
                                }.bind(this)
                            ),
                                this.$minus.on(
                                    "click",
                                    function () {
                                        var a = this.validateQty(this.$input.val());
                                        this.subtractQty(a);
                                    }.bind(this)
                                ),
                                this.$input.on(
                                    "change",
                                    function () {
                                        var a = this.validateQty(this.$input.val());
                                        this.changeQty(a);
                                    }.bind(this)
                                );
                        },
                        addQty: function (a) {
                            this.changeQty(a + 1);
                        },
                        subtractQty: function (b) {
                            var a = b - 1;
                            a <= this.minValue && (a = this.minValue), this.changeQty(a);
                        },
                        changeQty: function (b) {
                            this.$input.val(b), a("body").trigger("qty" + this.options.namespace, [this.options.key, b]);
                        },
                        validateQty: function (a) {
                            return (parseFloat(a) != parseInt(a) || isNaN(a)) && (a = 1), parseInt(a);
                        },
                    })),
                    b
                );
            })()),
            (theme.CartDrawer = (function () {
                var c = { namespace: ".ajaxcart" },
                    d = { drawer: "#CartDrawer", container: "#CartContainer", template: "#CartTemplate", fixedFooter: ".drawer__footer--fixed", fixedInnerContent: ".drawer__inner--has-fixed-footer", cartBubble: ".cart-link__bubble" };
                function b() {
                    (this.status = { loaded: !1, loading: !1 }), (this.drawer = new theme.Drawers("CartDrawer", "cart"));
                    var b = a(d.template).html();
                    (this.template = Handlebars.compile(b)), theme.cart.getCart().then(this.buildCart.bind(this)), this.initEventListeners();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        initEventListeners: function () {
                            a("body").on("updateCart" + c.namespace, this.initQtySelectors.bind(this)),
                                a("body").on("updateCart" + c.namespace, this.sizeFooter.bind(this)),
                                a("body").on("updateCart" + c.namespace, this.updateCartNotification.bind(this)),
                                a("body").on("drawerOpen.CartDrawer", this.sizeFooter.bind(this)),
                                a(window).on("resize" + c.namespace, a.debounce(150, this.sizeFooter.bind(this))),
                                a("body").on(
                                    "added.ajaxProduct",
                                    function () {
                                        theme.cart.getCart().then(
                                            function (a) {
                                                this.buildCart(a, !0);
                                            }.bind(this)
                                        );
                                    }.bind(this)
                                );
                        },
                        updateFreeShippingCalculation: function (d) {
                            var a = document.querySelector(".product-single__meta .product-message__text");
                            if (a) {
                                var b,
                                    c = (45 - d.total_price / 100).toFixed(2);
                                (b = c <= 0 ? "You have free shipping in the US!" : "Spend $" + c + " USD more to receive free shipping!"), (a.textContent = b);
                            }
                        },
                        buildCart: function (b, j) {
                            if ((this.loading(!0), this.emptyCart(), this.updateFreeShippingCalculation(b), 0 === b.item_count)) a(d.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + "</p>");
                            else {
                                var k = [],
                                    m = {},
                                    e = {},
                                    f = 1;
                                let l = b.total_price,
                                    g = b.total_discount,
                                    h = !1,
                                    i = "/cart";
                                a.each(b.items, function (t, c) {
                                    var n;
                                    let u = t + 1;
                                    n = null !== c.image ? c.image.replace(/(\.[^.]*)$/, "_180x$1") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                                    let o = `/cart/change?line=${u}&quantity=0`,
                                        j = c.price,
                                        p = c.price - c.total_discount / c.quantity,
                                        q = c.price !== c.price - c.total_discount,
                                        r = !1,
                                        s = 0;
                                    if (null !== c.properties) {
                                        let d = c.properties["_bundle_price"];
                                        if (null != d) {
                                            let v = c.properties["_bundle_id"];
                                            (j = d = Math.round(d)), (l += d), (h = !0), (i = "/apps/bundles/cart");
                                            let e = c.properties["_original_bundle_price"];
                                            null != e && (e = Math.round(e)) > d && ((j = e), (p = d), (q = !0), (addToTotal = e));
                                            for (let g = 0; g < window.bundles.length; g++) {
                                                let w = parseInt(window.bundles[g].bundleID),
                                                    x = window.bundles[g].bundleProduct;
                                                v === w &&
                                                    "" != x &&
                                                    (a.each(b.items, function (c, a) {
                                                        let b = a.properties && a.properties["_bundle_id"];
                                                        null != b && b === w && (s += 1), a.handle === x && (r = a.variant_id);
                                                    }),
                                                    (s -= 1));
                                            }
                                        }
                                        r && (o = `/cart/update?updates[${c.variant_id}]=0&updates[${r}]=${s}`);
                                    }
                                    (f += 2),
                                        (m = {
                                            key: c.key,
                                            id: c.id,
                                            url: c.url,
                                            img: n,
                                            animationRow: f,
                                            name: c.product_title,
                                            variation: c.variant_title,
                                            properties: c.properties,
                                            itemQty: c.quantity,
                                            price: theme.Currency.formatMoney(j, theme.settings.moneyFormat),
                                            discountedPrice: theme.Currency.formatMoney(p, theme.settings.moneyFormat),
                                            discounts: c.discounts,
                                            discountsApplied: q,
                                            vendor: c.vendor,
                                            removeLink: o,
                                        }),
                                        k.push(m);
                                }),
                                    1 === b.items.length && ((h = !1), (i = "/cart")),
                                    (f += 2),
                                    (e = {
                                        items: k,
                                        note: b.note,
                                        lastAnimationRow: f,
                                        totalPrice: theme.Currency.formatMoney(l, theme.settings.moneyFormat),
                                        totalCartDiscount: 0 === g ? 0 : theme.strings.cartSavings.replace("[savings]", theme.Currency.formatMoney(g, theme.settings.moneyFormat)),
                                        hasBundle: h,
                                        formAction: i,
                                    }),
                                    a(d.container).append(this.template(e));
                            }
                            (this.status.loaded = !0),
                                this.loading(!1),
                                a("body").hasClass("currencies-enabled") && theme.currencySwitcher.ajaxrefresh(),
                                a("body").trigger("updateCart" + c.namespace, b),
                                window.Shopify &&
                                    Shopify.StorefrontExpressButtons &&
                                    (Shopify.StorefrontExpressButtons.initialize(),
                                    setTimeout(
                                        function () {
                                            this.sizeFooter();
                                        }.bind(this),
                                        800
                                    )),
                                !0 === j && this.drawer.open();
                        },
                        initQtySelectors: function () {
                            a(d.container)
                                .find(".js-qty__wrapper")
                                .each(
                                    function (c, b) {
                                        new theme.QtySelector(a(b), { namespace: ".cart-drawer" });
                                    }.bind(this)
                                ),
                                a("body").on("qty.cart-drawer", this.updateItem.bind(this));
                        },
                        updateItem: function (c, a, b) {
                            this.status.loading ||
                                (this.loading(!0),
                                theme.cart
                                    .changeItem(a, b)
                                    .then(
                                        function (a) {
                                            this.updateSuccess(a);
                                        }.bind(this)
                                    )
                                    .catch(
                                        function (a) {
                                            this.updateError(a);
                                        }.bind(this)
                                    )
                                    .always(
                                        function () {
                                            this.loading(!1);
                                        }.bind(this)
                                    ));
                        },
                        loading: function (b) {
                            (this.status.loading = b), b ? a(d.container).addClass("is-loading") : a(d.container).removeClass("is-loading");
                        },
                        emptyCart: function () {
                            a(d.container).empty();
                        },
                        updateSuccess: function (a) {
                            this.buildCart(a);
                        },
                        updateError: function (a) {
                            a.responseJSON && a.responseJSON.description && console.warn(a.responseJSON.description);
                        },
                        sizeFooter: function () {
                            if (a(d.drawer).hasClass("drawer--has-fixed-footer")) {
                                var b = a(d.drawer).find(d.fixedFooter).removeAttr("style"),
                                    e = a(d.drawer).find(d.fixedInnerContent).removeAttr("style"),
                                    c = b.outerHeight();
                                e.css("bottom", c), b.css("height", c);
                            }
                        },
                        updateCartNotification: function (c, b) {
                            b.items.length > 0 ? a(d.cartBubble).addClass("cart-link__bubble--visible") : a(d.cartBubble).removeClass("cart-link__bubble--visible");
                        },
                    })),
                    b
                );
            })()),
            (theme.AjaxProduct = (function () {
                var c = { loading: !1 };
                function b(a) {
                    (this.$form = a), (this.$addToCart = this.$form.find(".add-to-cart")), this.$form.length && this.$form.on("submit", this.addItemFromForm.bind(this));
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        addItemFromForm: function (a, d) {
                            if ((a.preventDefault(), a.stopPropagation(), a.stopImmediatePropagation(), c.loading)) {
                                console.warn("already adding item to cart | bail");
                                return;
                            }
                            this.$addToCart.addClass("btn--loading"), (c.loading = !0);
                            var b = this.$form.serialize();
                            theme.cart
                                .addItemFromForm(b)
                                .then(
                                    function (a) {
                                        this.success(a);
                                    }.bind(this)
                                )
                                .catch(
                                    function (a) {
                                        this.error(a);
                                    }.bind(this)
                                )
                                .always(
                                    function () {
                                        (c.loading = !1), this.$addToCart.removeClass("btn--loading");
                                    }.bind(this)
                                );
                        },
                        success: function (b) {
                            a.ajax({
                                url: "/pages/cart-drawer",
                                type: "GET",
                                success: function (b) {
                                    a(".drawer_update").html(a(b).find(".drawer__inner2").html());
                                },
                            }),
                                this.$form.find(".errors").remove(),
                                a("body").trigger("added.ajaxProduct");
                        },
                        error: function (a) {
                            this.$form.find(".errors").remove(),
                                a.responseJSON && a.responseJSON.description && (console.warn(a.responseJSON.description), this.$form.prepend('<div class="errors text-center">' + a.responseJSON.description + "</div>"));
                        },
                    })),
                    b
                );
            })()),
            (theme.collapsibles = (function () {
                var b = { trigger: ".collapsible-trigger", module: ".collapsible-content", moduleInner: ".collapsible-content__inner" },
                    c = { hide: "hide", open: "is-open", autoHeight: "collapsible--auto-height" },
                    d = !1;
                function e(a, e, b, f) {
                    if ((a.removeClass(c.hide).prepareTransition().css("height", e).toggleClass(c.open, !b), !b && f)) {
                        var g = a;
                        window.setTimeout(function () {
                            g.css("height", "auto"), (d = !1);
                        }, 500);
                    } else d = !1;
                }
                return {
                    init: function () {
                        a(b.trigger).each(function () {
                            var b = a(this),
                                d = b.hasClass(c.open);
                            b.attr("aria-expanded", d);
                        }),
                            a("body, .modal__inner").on("click", b.trigger, function () {
                                if (!d) {
                                    d = !0;
                                    var g = a(this),
                                        f = g.hasClass(c.open),
                                        i = a("#" + g.attr("aria-controls")),
                                        j = i.find(b.moduleInner).outerHeight(),
                                        h = g.hasClass(c.autoHeight);
                                    f &&
                                        h &&
                                        setTimeout(function () {
                                            e(i, (j = 0), f, h);
                                        }, 0),
                                        f && !h && (j = 0),
                                        g.attr("aria-expanded", !f).toggleClass(c.open, !f),
                                        e(i, j, f, h);
                                }
                            });
                    },
                };
            })()),
            (theme.headerNav = (function () {
                var b,
                    c,
                    d,
                    e,
                    f,
                    g,
                    h = a(document.documentElement).add("body"),
                    i = a("#MainContent"),
                    j = {
                        wrapper: ".header-wrapper",
                        siteHeader: ".site-header",
                        searchBtn: ".js-search-header",
                        closeSearch: ".js-search-header-close",
                        searchContainer: ".site-header__search-container",
                        logoContainer: ".site-header__logo",
                        logo: ".site-header__logo img",
                        navigation: ".site-navigation",
                        navContainerWithLogo: ".header-item--logo",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                    },
                    k = { hasDropdownClass: "site-nav--has-dropdown", hasSubDropdownClass: "site-nav__deep-dropdown-trigger", dropdownActive: "is-focused" },
                    l = { namespace: ".siteNav", wrapperOverlayed: !1, overlayedClass: "is-light", stickyEnabled: !1, stickyActive: !1, stickyClass: "site-header--stuck", openTransitionClass: "site-header--opening", lastScroll: 0 };
                function m() {
                    a(document.activeElement).trigger("blur"),
                        h.removeClass("js-drawer-open js-drawer-open--search").off(l.namespace),
                        a(j.searchContainer).removeClass("is-active"),
                        slate.a11y.removeTrapFocus({ $container: a(j.searchContainer), namespace: "header_search" }),
                        slate.a11y.unlockMobileScrolling(l.namespace),
                        i.off("click" + l.namespace),
                        h.off("keyup" + l.namespace);
                }
                function n() {
                    a(j.logo).each(function () {
                        var b = a(this),
                            d = b.width(),
                            c = b.closest(".grid__item").width();
                        d > c ? b.css("maxWidth", c) : b.removeAttr("style");
                    });
                }
                function o() {
                    a(".site-header-sticky").css("height", g.outerHeight(!0));
                }
                function p() {
                    var tni = b.scrollTop();
                    if (tni > 250) {
                        if (l.stickyActive) return;
                        (l.stickyActive = !0),
                            g.addClass(l.stickyClass),
                            l.wrapperOverlayed && f.removeClass(l.overlayedClass),
                            setTimeout(function () {
                                g.addClass(l.openTransitionClass);
                                a("body").addClass('tni_sticky_header_active');
                                console.log("sddd");
                            }, 100);
                    } else {
                        if (!l.stickyActive) return;
                        (l.stickyActive = !1), g.removeClass(l.openTransitionClass).removeClass(l.stickyClass),a("body").removeClass('tni_sticky_header_active'), l.wrapperOverlayed && f.addClass(l.overlayedClass);
                    }
                    l.lastScroll = tni;
                }
                return {
                    init: function () {
                        (b = a(window)),
                            (c = a(j.navContainerWithLogo)),
                            (d = a(j.logoContainer)),
                            (e = a(j.navigation)),
                            (f = a(j.wrapper)),
                            (g = a(j.siteHeader)),
                            (l.stickyEnabled = g.data("sticky")),
                            l.stickyEnabled &&
                                ((l.wrapperOverlayed = f.hasClass(l.overlayedClass)),
                                (l.lastScroll = 0),
                                g.wrap('<div class="site-header-sticky"></div>'),
                                o(),
                                b.on("resize" + l.namespace, a.debounce(50, o)),
                                b.on("scroll" + l.namespace, a.throttle(15, p)),
                                Shopify &&
                                    Shopify.designMode &&
                                    setTimeout(function () {
                                        o();
                                    }, 250)),
                            (function () {
                                var b = !1,
                                    c = !1,
                                    d = !1;
                                function e(e) {
                                    var c = e.parent();
                                    if ((c.hasClass(k.hasDropdownClass) && (c.addClass(k.dropdownActive), (b = !0)), !theme.config.isTouch && !d)) {
                                        var f = theme.config.isTouch ? "touchend" : "click";
                                        (d = !0),
                                            a("body").on(f + l.namespace, function () {
                                                g(), a("body").off(l.namespace), (d = !1);
                                            });
                                    }
                                }
                                function f(b, d) {
                                    var a = b.parent();
                                    (a.hasClass(k.hasSubDropdownClass) || d) && (a.addClass(k.dropdownActive), (c = !0));
                                }
                                function g() {
                                    h(), i();
                                }
                                function h() {
                                    a(j.navItems).removeClass(k.dropdownActive);
                                }
                                function i() {
                                    a(j.navDropdownLinks).parent().removeClass(k.dropdownActive);
                                }
                                theme.config.isTouch &&
                                    (a(j.navLinksWithDropdown).on("touchend" + l.namespace, function (c) {
                                        var b = a(this);
                                        b.parent().hasClass(k.dropdownActive) ? window.location.replace(b.attr("href")) : (c.preventDefault(), g(), e(b));
                                    }),
                                    a(j.navDropdownLinks).on("touchend" + l.namespace, function (d) {
                                        var b = a(this),
                                            c = b.parent();
                                        c.hasClass(k.hasSubDropdownClass) ? (c.hasClass(k.dropdownActive) ? window.location.replace(b.attr("href")) : (d.preventDefault(), i(), f(b))) : window.location.replace(b.attr("href"));
                                    })),
                                    a(j.navLinks).on("focusin mouseover" + l.namespace, function () {
                                        b && h(), c && i(), e(a(this));
                                    }),
                                    a(j.navLinks).on("mouseleave" + l.namespace, function () {
                                        g();
                                    }),
                                    a(j.navDropdownLinks).on("focusin" + l.namespace, function () {
                                        i(), f(a(this), !0);
                                    });
                            })(),
                            a(j.searchBtn).on("click" + l.namespace, function (b) {
                                b.preventDefault(),
                                    a(j.searchContainer).addClass("is-active"),
                                    h.addClass("js-drawer-open js-drawer-open--search"),
                                    slate.a11y.trapFocus({ $container: a(j.searchContainer), namespace: "header_search", $elementToFocus: a(j.searchContainer).find("input") }),
                                    theme.config.bpSmall && l.stickyEnabled && l.lastScroll < 300 && window.scrollTo(0, 0),
                                    slate.a11y.lockMobileScrolling(l.namespace),
                                    i.on("click" + l.namespace, function () {
                                        return m(), !1;
                                    }),
                                    h.on("keyup" + l.namespace, function (a) {
                                        27 === a.keyCode && m();
                                    });
                            }),
                            a(j.closeSearch).on("click" + l.namespace, function () {
                                m();
                            }),
                            b.on("load" + l.namespace, n),
                            b.on("resize" + l.namespace, a.debounce(150, n));
                    },
                    unload: function () {
                        a(window).off(l.namespace), a(j.searchBtn).off(l.namespace), a(j.closeSearch).off(l.namespace), h.off(l.namespace), a(j.navLinks).off(l.namespace), a(j.navDropdownLinks).off(l.namespace);
                    },
                };
            })()),
            (theme.articleImages = (function () {
                var b = {};
                function c() {
                    b.$rteImages.find("img").each(function () {
                        var c = a(this),
                            d = c.attr("style");
                        (!d || "float: none;" == d) && c.width() < b.$rteImages.width() && c.addClass("rte__no-indent");
                    });
                }
                return {
                    init: function () {
                        (b.$rteImages = a(".rte--indented-images")), b.$rteImages.length && a(window).on("load", c);
                    },
                };
            })()),
            (theme.Slideshow = (function () {
                this.$slideshow = null;
                var c = { next: "is-next", init: "is-init", wrapper: "slideshow-wrapper", slideshow: "slideshow", currentSlide: "slick-current", pauseButton: "slideshow__pause", isPaused: "is-paused" };
                function b(d, b) {
                    (this.$slideshow = a(d)),
                        (this.$wrapper = this.$slideshow.closest("." + c.wrapper)),
                        (this.$pause = this.$wrapper.find("." + c.pauseButton)),
                        (this.settings = {
                            accessibility: !0,
                            arrows: !!b.arrows,
                            dots: !!b.dots,
                            draggable: !0,
                            touchThreshold: 5,
                            pauseOnHover: !1,
                            autoplay: this.$slideshow.data("autoplay"),
                            autoplaySpeed: this.$slideshow.data("speed"),
                        }),
                        this.$slideshow.on("init", this.init.bind(this)),
                        this.$slideshow.slick(this.settings),
                        this.$pause.on("click", this._togglePause.bind(this));
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        init: function (b, a) {
                            (this.$slideshowList = a.$list), (this.$slickDots = a.$dots), (this.$allSlides = a.$slides), (this.slideCount = a.slideCount), this.$slideshow.addClass(c.init), this._a11y(), this._clonedLazyloading();
                        },
                        destroy: function () {
                            this.$slideshow.slick("unslick");
                        },
                        _play: function () {
                            this.$slideshow.slick("slickPause"), a(c.pauseButton).addClass("is-paused");
                        },
                        _pause: function () {
                            this.$slideshow.slick("slickPlay"), a(c.pauseButton).removeClass("is-paused");
                        },
                        _togglePause: function () {
                            var b = this._getSlideshowId(this.$pause);
                            this.$pause.hasClass(c.isPaused) ? (this.$pause.removeClass(c.isPaused), a(b).slick("slickPlay")) : (this.$pause.addClass(c.isPaused), a(b).slick("slickPause"));
                        },
                        _getSlideshowId: function (a) {
                            return "#Slideshow-" + a.data("id");
                        },
                        _activeSlide: function () {
                            return this.$slideshow.find(".slick-active");
                        },
                        _currentSlide: function () {
                            return this.$slideshow.find(".slick-current");
                        },
                        _nextSlide: function (a) {
                            return this.$slideshow.find('.slideshow__slide[data-slick-index="' + a + '"]');
                        },
                        _a11y: function () {
                            var b = this.$slideshowList,
                                d = this.settings.autoplay;
                            b &&
                                (b.removeAttr("aria-live"),
                                a(c.wrapper).on(
                                    "focusin",
                                    function (e) {
                                        a(c.wrapper).has(e.target).length && (b.attr("aria-live", "polite"), d && this._pause());
                                    }.bind(this)
                                ),
                                a(c.wrapper).on(
                                    "focusout",
                                    function (e) {
                                        a(c.wrapper).has(e.target).length && (b.removeAttr("aria-live"), d && this._play());
                                    }.bind(this)
                                ));
                        },
                        _clonedLazyloading: function () {
                            var b = this.$slideshow;
                            b.find(".slick-slide").each(
                                function (e, d) {
                                    var c = a(d);
                                    if (c.hasClass("slick-cloned")) {
                                        var f = c.data("id"),
                                            g = c.find(".hero__image").removeClass("lazyloading").addClass("lazyloaded");
                                        setTimeout(function () {
                                            var a = b.find(".slideshow__slide--" + f + ":not(.slick-cloned) .hero__image").attr("style");
                                            a && g.attr("style", a);
                                        }, this.settings.autoplaySpeed / 1.5);
                                    }
                                }.bind(this)
                            );
                        },
                    })),
                    b
                );
            })()),
            (theme.announcementBar = (function () {
                var b = { bar: ".announcement", text: ".announcement__text", closeBtn: ".announcement__close" },
                    c = { opening: "announcement--opening", closed: "announcement--closed" },
                    d = { namespace: ".announcementBar" };
                function e() {
                    a(b.bar).removeClass(c.closed), f();
                }
                function f() {
                    var d = a(b.text).outerHeight(!0);
                    a(b.bar).addClass(c.opening).css({ "max-height": d });
                }
                function g() {
                    return a(b.text).data("text");
                }
                return {
                    init: function () {
                        a(b.closeBtn).length &&
                            (theme.config.hasSessionStorage &&
                                "hidden" !== sessionStorage[g()] &&
                                window.setTimeout(function () {
                                    e();
                                }, 2e3),
                            theme.config.hasSessionStorage ||
                                window.setTimeout(function () {
                                    e();
                                }, 2e3),
                            a(b.closeBtn).on("click", function (d) {
                                d.preventDefault(), theme.config.hasSessionStorage && sessionStorage.setItem(g(), "hidden"), a(b.bar).addClass(c.closed);
                            }),
                            a(window).on("resize" + d.namespace, a.debounce(150, f)));
                    },
                    unload: function () {
                        a(window).off(d.namespace);
                    },
                };
            })()),
            (theme.currencySwitcher = (function () {
                var c = { dataDiv: "#CurrencyData", picker: ".currency-input" },
                    d = {};
                function b() {
                    var b = a(c.picker).val();
                    Currency.convertAll(Currency.currentCurrency, b);
                }
                return {
                    init: function () {
                        var f,
                            e = a(c.dataDiv);
                        e.length &&
                            (($primaryPicker = a("#CurrencyPicker-header")),
                            ($drawerPicker = a("#CurrencyPicker-drawer")),
                            $primaryPicker.on("change", function () {
                                $drawerPicker.val(a(this).val());
                            }),
                            $drawerPicker.on("change", function () {
                                $primaryPicker.val(a(this).val());
                            }),
                            (d = { currency: e.data("shop-currency"), default: e.data("default-currency"), format: e.data("format"), moneyFormat: e.data("money-format"), moneyCurrencyFormat: e.data("money-currency-format") }),
                            (Currency.format = d.format),
                            (Currency.money_format[d.currency] = d.moneyFormat),
                            (Currency.money_with_currency_format[d.currency] = d.moneyCurrencyFormat),
                            a("span.money span.money").each(function () {
                                a(this).parents("span.money").removeClass("money");
                            }),
                            a("span.money").each(function () {
                                a(this).attr("data-currency-" + d.currency, a(this).html());
                            }),
                            (f = Currency.cookie.read()),
                            null == f
                                ? d.currency !== d.default
                                    ? Currency.convertAll(d.currency, d.default)
                                    : (Currency.currentCurrency = d.default)
                                : a(c.picker).length && 0 === a(c.picker).find("option[value=" + f + "]").length
                                ? ((Currency.currentCurrency = d.currency), Currency.cookie.write(d.currency))
                                : f === d.currency
                                ? (Currency.currentCurrency = d.currency)
                                : Currency.convertAll(d.currency, f),
                            a(c.picker).val(Currency.currentCurrency).on("change", b));
                    },
                    refresh: b,
                    ajaxrefresh: function () {
                        var b = a(c.picker).val();
                        Currency.convertAll(d.currency, b);
                    },
                };
            })()),
            (theme.initQuickShop = function (b) {
                var c = [];
                a(".quick-product__btn").each(function () {
                    var b = a(this).data("product-id");
                    if (c.indexOf(b) > -1) {
                        a('.modal--quick-shop[data-product-id="' + b + '"]').each(function (b) {
                            b > 0 && a(this).remove();
                        });
                        return;
                    }
                    new theme.Modals("QuickShopModal-" + b, "quick-modal-" + b), c.push(b);
                });
            }),
            (theme.videoModal = function () {
                var c = {
                        width: 1280,
                        height: 720,
                        playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                    },
                    b = { triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]' };
                if (a(b.triggers).length) {
                    var d = new theme.Modals("VideoModal", "video-modal", { closeOffContentClick: !0, solid: !0 });
                    a(b.triggers).on("click", function (b) {
                        b.preventDefault(),
                            window.loadYouTube(),
                            theme.config.youTubeReady
                                ? e(b)
                                : a("body").on("youTubeReady", function () {
                                      e(b);
                                  });
                    });
                }
                function e(e) {
                    var g = a(e.currentTarget),
                        h = f(g.attr("href")),
                        b = a.extend({}, c, { videoId: h });
                    b.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
                    var i = new YT.Player("VideoHolder", b);
                    d.open(),
                        a("body").on("modalClose.VideoModal", function () {
                            setTimeout(function () {
                                i.destroy();
                            }, 500);
                        });
                }
                function f(b) {
                    var a = b.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);
                    return !!a && 11 == a[7].length && a[7];
                }
            }),
            (theme.customerTemplates = (function () {
                function b() {
                    a("#RecoverPasswordForm").toggleClass("hide"), a("#CustomerLoginForm").toggleClass("hide");
                }
                return {
                    init: function () {
                        var c, d;
                        "#recover" === window.location.hash && b(),
                            a("#RecoverPassword").on("click", function (a) {
                                a.preventDefault(), b();
                            }),
                            a("#HideRecoverPasswordLink").on("click", function (a) {
                                a.preventDefault(), b();
                            }),
                            a(".reset-password-success").length && a("#ResetSuccess").removeClass("hide"),
                            (c = a("#AddressNewForm")),
                            (d = a(".js-address-form")),
                            c.length &&
                                d.length &&
                                (Shopify &&
                                    a(".js-address-country").each(function () {
                                        var b = a(this),
                                            c = b.data("country-id"),
                                            d = b.data("province-id"),
                                            e = b.data("province-container-id");
                                        new Shopify.CountryProvinceSelector(c, d, { hideElement: e });
                                    }),
                                a(".address-new-toggle").on("click", function () {
                                    c.toggleClass("hide");
                                }),
                                a(".address-edit-toggle").on("click", function () {
                                    var b = a(this).data("form-id");
                                    a("#EditAddress_" + b).toggleClass("hide");
                                }),
                                a(".address-delete").on("click", function () {
                                    var b = a(this),
                                        c = b.data("form-id"),
                                        d = b.data("confirm-message");
                                    confirm(d || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + c, { parameters: { _method: "delete" } });
                                }));
                    },
                };
            })()),
            (theme.Product = (function () {
                var c,
                    d,
                    e = { onSale: "on-sale", disabled: "disabled", isModal: "is-modal", loading: "loading", loaded: "loaded", interactable: "video-interactable" },
                    f = { productVideo: ".product__video", videoParent: ".product__video-wrapper", currentSlide: ".slick-current", zoomImage: ".photo-zoom-link__initial" },
                    g = {},
                    h = [],
                    i = {
                        height: "480",
                        width: "850",
                        playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                        events: {
                            onReady: function (d) {
                                var c = a(d.target.a),
                                    b = c.attr("id");
                                (h[b] = d.target),
                                    h[b],
                                    p(c),
                                    "muted" === g[b].style ? h[b].mute().playVideo().pauseVideo() : q(c),
                                    (c.closest(f.currentSlide).length || 1 === c.data("image-count")) && "muted" === g[b].style && (h[b].playVideo(), l(b));
                            },
                            onStateChange: function (d) {
                                var b = a(d.target.a),
                                    c = b.attr("id"),
                                    e = h[c];
                                switch (d.data) {
                                    case -1:
                                        g[c].attemptedToPlay && (q(b), r(b));
                                        break;
                                    case 0:
                                        e.playVideo();
                                        break;
                                    case 1:
                                        q(b);
                                        break;
                                    case 3:
                                        g[c].attemptedToPlay = !0;
                                }
                            },
                        },
                    },
                    j = [],
                    k = { byline: !1, title: !1, portrait: !1, loop: !0 };
                function l(b) {
                    m(b), a(window).on("scroll." + b, { id: b }, a.throttle(150, m));
                }
                function m(c) {
                    var b;
                    if (((b = "string" == typeof c ? c : c.data.id), theme.isElementVisible(a("#" + b)))) {
                        if (g[b] && "unmuted" === g[b].style) return;
                        n(b);
                    } else o(b);
                }
                function n(a) {
                    h[a] && "function" == typeof h[a].playVideo && h[a].playVideo();
                }
                function o(a) {
                    h[a] && "function" == typeof h[a].pauseVideo && h[a].pauseVideo();
                }
                function p(a) {
                    a.closest(f.videoParent).addClass(e.loading);
                }
                function q(a) {
                    a.closest(f.videoParent).removeClass(e.loading).addClass(e.loaded);
                }
                function r(a) {
                    a.closest(f.videoParent).addClass(e.interactable);
                }
                function b(d) {
                    var c = (this.$container = a(d)),
                        b = (this.sectionId = c.attr("data-section-id"));
                    (this.inModal = c.closest(".modal").length),
                        this.$modal,
                        (this.settings = {
                            enableHistoryState: c.data("enable-history-state") || !1,
                            namespace: ".product-" + b,
                            zoom: c.data("image-zoom") || !1,
                            inventory: c.data("inventory") || !1,
                            modalInit: !1,
                            slickMainInitialized: !1,
                            slickThumbInitialized: !1,
                            hasImages: !0,
                            hasMultipleImages: !1,
                            imageSize: "620x",
                        }),
                        this.inModal && ((this.settings.enableHistoryState = !1), (this.settings.namespace = ".product-" + b + "-modal"), (this.$modal = a("#QuickShopModal-" + b))),
                        (this.selectors = {
                            variantsJson: "VariantsJson-" + b,
                            currentVariantJson: "CurrentVariantJson-" + b,
                            video: "ProductVideo-" + b,
                            photoThumbs: ".product__thumb-" + b,
                            thumbSlider: "#ProductThumbs-" + b,
                            mainSlider: "#ProductPhotos-" + b,
                            productImageMain: ".product-image-main--" + b,
                            priceWrapper: ".product__price-wrap-" + b,
                            price: "#ProductPrice-" + b,
                            comparePrice: "#ComparePrice-" + b,
                            priceA11y: "#PriceA11y-" + b,
                            comparePriceA11y: "#ComparePriceA11y-" + b,
                            sku: "#Sku-" + b,
                            inventory: "#ProductInventory-" + b,
                            addToCart: "#AddToCart-" + b,
                            addToCartText: "#AddToCartText-" + b,
                            originalSelectorId: "#ProductSelect-" + b,
                            singleOptionSelector: ".variant__input-" + b,
                            variantColorSwatch: ".variant__input--color-swatch-" + b,
                            modalFormHolder: "#ProductFormHolder-" + b,
                            formContainer: "#AddToCartForm-" + b,
                        }),
                        (this.$mainSlider = a(this.selectors.mainSlider)),
                        (this.$thumbSlider = a(this.selectors.thumbSlider)),
                        (this.$firstProductImage = this.$mainSlider.find("img").first()),
                        this.$firstProductImage.length || (this.settings.hasImages = !1),
                        this.init();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        init: function () {
                            this.inModal &&
                                (this.$container.addClass(e.isModal),
                                a("body")
                                    .off("modalOpen.QuickShopModal-" + this.sectionId)
                                    .off("modalClose.QuickShopModal-" + this.sectionId),
                                a("body").on("modalOpen.QuickShopModal-" + this.sectionId, this.openModalProduct.bind(this)),
                                a("body").on("modalClose.QuickShopModal-" + this.sectionId, this.closeModalProduct.bind(this))),
                                this.inModal || (this.stringOverrides(), this.formSetup(), this.productSetup(), this.checkIfVideos(), this.createImageCarousels());
                        },
                        formSetup: function () {
                            theme.settings.dynamicVariantsEnable &&
                                ("dropdown" === theme.settings.dynamicVariantType
                                    ? (this.$variantSelectors = { all: a(this.selectors.formContainer).find("select"), selected: a(this.selectors.formContainer).find("select") })
                                    : (this.$variantSelectors = { all: a(this.selectors.formContainer).find("input"), selected: a(this.selectors.formContainer).find("input:checked") })),
                                this.initQtySelector(),
                                this.initAjaxProductForm(),
                                this.initVariants();
                        },
                        productSetup: function () {
                            this.setImageSizes(), this.initImageSwitch();
                        },
                        stringOverrides: function () {
                            (theme.productStrings = theme.productStrings || {}), a.extend(theme.strings, theme.productStrings);
                        },
                        setImageSizes: function () {
                            if (this.settings.hasImages) {
                                var a = this.$firstProductImage[0].currentSrc;
                                a && (this.settings.imageSize = theme.Images.imageSize(a)), this.settings.zoom && (this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data("zoom-size")));
                            }
                        },
                        initVariants: function () {
                            if (document.getElementById(this.selectors.variantsJson)) {
                                this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
                                var b = {
                                    $container: this.$container,
                                    enableHistoryState: this.settings.enableHistoryState,
                                    singleOptionSelector: this.selectors.singleOptionSelector,
                                    originalSelectorId: this.selectors.originalSelectorId,
                                    variants: this.variantsObject,
                                };
                                a(this.selectors.variantColorSwatch).length &&
                                    a(this.selectors.variantColorSwatch).on(
                                        "change",
                                        function (c) {
                                            var b = a(c.currentTarget),
                                                d = b.data("color-name"),
                                                e = b.data("color-index");
                                            this.updateColorName(d, e);
                                        }.bind(this)
                                    ),
                                    (this.variants = new slate.Variants(b)),
                                    this.$container.on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this)),
                                    this.$container.on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this)),
                                    this.$container.on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this)),
                                    a(this.selectors.sku).length && this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this)),
                                    this.settings.inventory && this.$container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this)),
                                    theme.settings.dynamicVariantsEnable &&
                                        document.getElementById(this.selectors.currentVariantJson) &&
                                        ((this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML)),
                                        this.$variantSelectors.all.on("change" + this.settings.namespace, this.updateVariantAvailability.bind(this)),
                                        this.setCurrentVariantAvailability(this.currentVariantObject, !0));
                            }
                        },
                        updateColorName: function (b, c) {
                            a("#VariantColorLabel-" + this.sectionId + "-" + c).text(b);
                        },
                        setCurrentVariantAvailability: function (i) {
                            var b = { option1: [], option2: [], option3: [] };
                            this.disableVariantGroup(a(this.selectors.formContainer).find(".variant-input-wrap"));
                            var c = this.variantsObject.filter(function (a) {
                                    return i.id !== a.id && ((i.option2 === a.option2 && i.option3 === a.option3) || (i.option1 === a.option1 && i.option3 === a.option3) || (i.option1 === a.option1 && i.option2 === a.option2) || void 0);
                                }),
                                j = { variant: i };
                            for (var h in (c = Object.assign({}, j, c)))
                                if (c.hasOwnProperty(h)) {
                                    var d = c[h],
                                        e = d.option1,
                                        f = d.option2,
                                        g = d.option3;
                                    e && -1 === b.option1.indexOf(e) && b.option1.push(e), f && -1 === b.option2.indexOf(f) && b.option2.push(f), g && -1 === b.option3.indexOf(g) && b.option3.push(g);
                                }
                            b.option1.length && this.enableVariantOptionByValue(b.option1, "option1"),
                                b.option2.length && this.enableVariantOptionByValue(b.option2, "option2"),
                                b.option3.length && this.enableVariantOptionByValue(b.option3, "option3");
                        },
                        updateVariantAvailability: function (c, d, e) {
                            if (d && e)
                                var f = d,
                                    g = e;
                            else
                                var b = a(c.currentTarget),
                                    f = b.val() ? b.val() : c.currentTarget.value,
                                    g = b.data("index");
                            var h = this.variantsObject.filter(function (a) {
                                return a[g] === f;
                            });
                            a(this.selectors.formContainer)
                                .find(".variant-input-wrap")
                                .each(
                                    function (f, e) {
                                        var b = a(e),
                                            d = b.data("index");
                                        if (d !== g) {
                                            this.disableVariantGroup(b);
                                            for (var c = 0; c < h.length; c++) this.enableVariantOption(b, h[c][d]);
                                        }
                                    }.bind(this)
                                );
                        },
                        disableVariantGroup: function (a) {
                            "dropdown" === theme.settings.dynamicVariantType ? a.find("option").prop("disabled", !0) : (a.find("input").prop("disabled", !0), a.find("label").toggleClass("disabled", !0));
                        },
                        enableVariantOptionByValue: function (c, d) {
                            for (var e = a(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + d + '"]'), b = 0; b < c.length; b++) this.enableVariantOption(e, c[b]);
                        },
                        enableVariantOption: function (b, a) {
                            if (((a = a.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")), "dropdown" === theme.settings.dynamicVariantType)) b.find('option[value="' + a + '"]').prop("disabled", !1);
                            else {
                                var c = b.find('.variant-input[data-value="' + a + '"]');
                                c.find("input").prop("disabled", !1), c.find("label").toggleClass("disabled", !1);
                            }
                        },
                        updateCartButton: function (c) {
                            var b = c.variant;
                            b
                                ? b.available
                                    ? (a(this.selectors.addToCart).removeClass(e.disabled).prop("disabled", !1), a(this.selectors.addToCartText).html(theme.strings.addToCart))
                                    : (a(this.selectors.addToCart).addClass(e.disabled).prop("disabled", !0), a(this.selectors.addToCartText).html(theme.strings.soldOut))
                                : (a(this.selectors.addToCart).addClass(e.disabled).prop("disabled", !0), a(this.selectors.addToCartText).html(theme.strings.unavailable));
                        },
                        updatePrice: function (c) {
                            var b = c.variant;
                            b &&
                                (a(this.selectors.price).html(theme.Currency.formatMoney(b.price, theme.settings.moneyFormat)).show(),
                                b.compare_at_price > b.price
                                    ? (a(this.selectors.comparePrice).html(theme.Currency.formatMoney(b.compare_at_price, theme.settings.moneyFormat)),
                                      a(this.selectors.priceWrapper).removeClass("hide"),
                                      a(this.selectors.price).addClass(e.onSale),
                                      a(this.selectors.comparePriceA11y).attr("aria-hidden", "false"),
                                      a(this.selectors.priceA11y).attr("aria-hidden", "false"))
                                    : (a(this.selectors.priceWrapper).addClass("hide"),
                                      a(this.selectors.price).removeClass(e.onSale),
                                      a(this.selectors.comparePriceA11y).attr("aria-hidden", "true"),
                                      a(this.selectors.priceA11y).attr("aria-hidden", "true")),
                                a("body").hasClass("currencies-enabled") && theme.currencySwitcher.ajaxrefresh());
                        },
                        updateSku: function (d) {
                            var b = d.variant,
                                c = "";
                            b && (b.sku && (c = b.sku), a(this.selectors.sku).html(c));
                        },
                        updateInventory: function (f) {
                            var b = f.variant,
                                c = !1,
                                d = 0,
                                e = a(this.selectors.inventory);
                            b && "shopify" === b.inventory_management && ((c = !0), 0 === (d = window.inventories[this.sectionId][b.id]) && (c = !1)),
                                c ? e.removeClass("hide").text(theme.strings.stockLabel.replace("[count]", d)) : e.addClass("hide");
                        },
                        updateVariantImage: function (d) {
                            var b = d.variant;
                            theme.Images.getSizedImageUrl(b.featured_image.src, this.settings.imageSize), this.settings.zoom && theme.Images.getSizedImageUrl(b.featured_image.src, this.settings.imageZoomSize);
                            var e = a('.product__thumb[data-id="' + b.featured_image.id + '"]'),
                                c = this._slideIndex(e.closest(".product__thumb-item"));
                            void 0 !== c && this.$mainSlider.slick("slickGoTo", c);
                        },
                        initImageSwitch: function () {
                            a(this.selectors.photoThumbs).length &&
                                a(this.selectors.photoThumbs).on("click", function (a) {
                                    a.preventDefault();
                                });
                        },
                        checkIfVideos: function () {
                            var b = this.$mainSlider.find(f.productVideo);
                            if (!b.length) return !1;
                            var c = [];
                            return (
                                b.each(function () {
                                    var b = a(this).data("video-type");
                                    0 > c.indexOf(b) && c.push(b);
                                }),
                                c.indexOf("youtube") > -1 &&
                                    (theme.config.youTubeReady
                                        ? this.loadYoutubeVideos(b)
                                        : (window.loadYouTube(),
                                          a("body").on(
                                              "youTubeReady" + this.settings.namespace,
                                              function () {
                                                  this.loadYoutubeVideos(b);
                                              }.bind(this)
                                          ))),
                                c.indexOf("vimeo") > -1 &&
                                    (d
                                        ? this.loadVimeoVideos(b)
                                        : (window.loadVimeo(),
                                          a("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  this.loadVimeoVideos(b);
                                              }.bind(this)
                                          ))),
                                c.indexOf("mp4") > -1 && this.loadMp4Videos(b),
                                c
                            );
                        },
                        loadMp4Videos: function (b) {
                            b.each(function () {
                                var b = a(this);
                                if ("mp4" == b.data("video-type")) {
                                    var c = b.attr("id");
                                    b.data("video-id"), (g[this.id] = { type: "mp4", divId: c, style: b.data("video-style") });
                                }
                            });
                        },
                        loadVimeoVideos: function (c) {
                            for (var b in (c.each(function () {
                                var b = a(this);
                                if ("vimeo" == b.data("video-type")) {
                                    var c = b.attr("id"),
                                        d = b.data("video-id");
                                    g[this.id] = { type: "vimeo", divId: c, id: d, style: b.data("video-style"), width: b.data("video-width"), height: b.data("video-height") };
                                }
                            }),
                            g))
                                if ("vimeo" == g[b].type) {
                                    var e = a.extend({}, k, g[b]);
                                    j[b] = new Vimeo.Player(g[b].divId, e);
                                }
                            d = !0;
                        },
                        autoplayVimeoVideo: function (b) {
                            if (theme.config.bpSmall) {
                                var c = a("#" + b);
                                q(c);
                            } else this.requestToPlayVimeoVideo(b);
                        },
                        requestToPlayVimeoVideo: function (b) {
                            var c = a("#" + b);
                            if ((p(c), !d)) {
                                a("body").on(
                                    "vimeoReady" + this.settings.namespace,
                                    function () {
                                        this.playVimeoVideo(b);
                                    }.bind(this)
                                );
                                return;
                            }
                            this.playVimeoVideo(b);
                        },
                        playVimeoVideo: function (b) {
                            j[b].play(), "muted" === g[b].style && j[b].setVolume(0);
                            var c = a("#" + b);
                            q(c);
                        },
                        stopVimeoVideo: function (a) {
                            if (theme.config.vimeoReady) {
                                if (a) j[a].pause();
                                else for (key in j) "function" == typeof j[key].pause && j[key].pause();
                            }
                        },
                        loadYoutubeVideos: function (e) {
                            for (var b in (e.each(function () {
                                var b = a(this);
                                if ("youtube" == b.data("video-type")) {
                                    var c = b.attr("id"),
                                        d = b.data("youtube-id");
                                    g[this.id] = { type: "youtube", id: c, videoId: d, style: b.data("video-style"), width: b.data("video-width"), height: b.data("video-height"), attemptedToPlay: !1 };
                                }
                            }),
                            g))
                                if ("youtube" === g[b].type && g.hasOwnProperty(b)) {
                                    var d = a.extend({}, i, g[b]);
                                    "muted" === d.style || ((d.playerVars.controls = 1), (d.playerVars.autoplay = 0)), (h[b] = new YT.Player(b, d));
                                }
                            c = !0;
                        },
                        requestToPlayYoutubeVideo: function (b, c) {
                            if (theme.config.youTubeReady) {
                                var d = a("#" + b);
                                if ((p(d), "function" != typeof h[b].playVideo)) {
                                    var e = this;
                                    setTimeout(function () {
                                        e.playYoutubeVideo(b, c);
                                    }, 1e3);
                                    return;
                                }
                                this.playYoutubeVideo(b, c);
                            }
                        },
                        playYoutubeVideo: function (b, c) {
                            var d = a("#" + b);
                            q(d), "function" == typeof h[b].playVideo && h[b].playVideo(), c || l(b);
                        },
                        stopYoutubeVideo: function (b) {
                            if (theme.config.youTubeReady) {
                                if (b && h[b]) "function" == typeof h[b].pauseVideo && h[b].pauseVideo(), a(window).off("scroll." + b);
                                else for (key in h) "function" == typeof h[key].pauseVideo && (h[key].pauseVideo(), a(window).off("scroll." + key));
                            }
                        },
                        playMp4Video: function (c) {
                            var b = a("#" + c);
                            q(b), b[0].play();
                        },
                        stopMp4Video: function (b) {
                            if (b) a("#" + b)[0].pause();
                            else
                                for (var c in g)
                                    if ("mp4" === g[c].type) {
                                        var d = a("#" + g[c].divId)[0];
                                        "function" == typeof d.pause && d.pause();
                                    }
                        },
                        initZoom: function (b) {
                            var c = b.parent().data("zoom-size");
                            b.parent()
                                .on("click", function (a) {
                                    a.preventDefault();
                                })
                                .zoom({
                                    on: "click",
                                    url: c,
                                    duration: 180,
                                    touch: !1,
                                    onZoomIn: function () {
                                        a(this).addClass("photo-zoom-linked");
                                    },
                                    onZoomOut: function () {
                                        a(this).removeClass("photo-zoom-linked");
                                    },
                                });
                        },
                        destroyZoom: function (a) {
                            a.trigger("zoom.destroy");
                        },
                        createImageCarousels: function () {
                            if (!this.$thumbSlider.length || a(this.selectors.photoThumbs).length < 2) {
                                var c = a(this.selectors.productImageMain).find(f.productVideo);
                                c.length && this.initVideo(c), this.settings.zoom && this.initZoom(a(this.selectors.productImageMain).find(f.zoomImage));
                                return;
                            }
                            this.settings.hasMultipleImages = !0;
                            var e = this.$mainSlider.find(".starting-slide"),
                                d = this._slideIndex(e);
                            this.$mainSlider.off("init"),
                                this.$mainSlider.off("beforeChange"),
                                this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                                this.$mainSlider.on("beforeChange", this.beforeSlideChange.bind(this)),
                                this.$thumbSlider.on("init", this.thumbSlideInit.bind(this));
                            var b = "beside" === this.$thumbSlider.data("position");
                            this.$mainSlider.slick({ adaptiveHeight: !b, asNavFor: this.selectors.thumbSlider, infinite: !1, arrows: 1, dots: 1, initialSlide: d }),
                                this.$thumbSlider.slick({
                                    arrows:true,
                                    prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
                                    nextArrow:"<button type='button' class='slick-next pull-right'></button>",
                                    asNavFor: this.selectors.mainSlider,
                                    slidesToShow: b ? 3 : 5,
                                    slidesToScroll: 1,                                    
                                    dots: 1,
                                    vertical: b,
                                    verticalSwiping: b,
                                    focusOnSelect: !0,
                                    infinite: !1,
                                    customHeightMatching: b,
                                    customSlideAdvancement: !0,
                                    initialSlide: d,
                                    responsive: [{ breakpoint: 590, settings: { slidesToShow: 5, slidesToScroll: 1, vertical: !1, verticalSwiping: !1 } }],
                                }),
                                AOS && AOS.refresh();
                        },
                        destroyImageCarousels: function () {
                            this.$mainSlider && this.settings.slickMainInitialized && (this.$mainSlider.slick("unslick"), (this.settings.slickMainInitialized = !1)),
                                this.$thumbSlider && this.settings.slickThumbInitialized && (this.$thumbSlider.slick("unslick"), (this.settings.slickThumbInitialized = !1));
                        },
                        mainSlideInit: function (c, b) {
                            var a = b.$slider.find(f.currentSlide).find(f.productVideo);
                            (this.settings.slickMainInitialized = !0), a.length && this.initVideo(a);
                            jQuery(".tni-ProductPhotos-product-page-selector").removeClass("tni-ProductPhotos-product-page");
                        },
                        thumbSlideInit: function (a, b) {
                            this.settings.slickThumbInitialized = !0;
                            jQuery(".product__thumbs").show();
                        },
                        initVideo: function (f) {
                            var e = f.data("video-type"),
                                b = f.attr("id");
                            "mp4" === e && "muted" === g[b].style && this.playMp4Video(b),
                                "youtube" === e && c && "muted" === g[b].style && this.requestToPlayYoutubeVideo(b),
                                "vimeo" === e &&
                                    (d
                                        ? this.playOrShowVimeo(b)
                                        : a("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  this.playOrShowVimeo(b);
                                              }.bind(this)
                                          )),
                                this.inModal && this.resizeSlides();
                        },
                        playOrShowVimeo: function (b) {
                            g[b] && "muted" === g[b].style ? this.autoplayVimeoVideo(b) : g[b] && "unmuted" === g[b].style && q(a("#" + b));
                        },
                        getVideoType: function (a) {
                            return a.data("video-type");
                        },
                        getVideoId: function (a) {
                            return a.attr("id");
                        },
                        beforeSlideChange: function (u, p, r, l) {
                            var m = p.$slider,
                                n = m.find(f.currentSlide),
                                h = n.find(".product__video"),
                                o = m.find('.slick-slide[data-slick-index="' + l + '"]'),
                                i = o.find(".product__video");
                            if (r !== l && h.length) {
                                var j = this.getVideoType(h),
                                    e = this.getVideoId(h);
                                e && ("youtube" === j && this.stopYoutubeVideo(e), "mp4" === j && this.stopMp4Video(e), "vimeo" === j && this.stopVimeoVideo(e));
                            }
                            if (i.length) {
                                var k = this.getVideoType(i),
                                    b = this.getVideoId(i);
                                b &&
                                    "vimeo" === k &&
                                    (d
                                        ? g[b] && "muted" === g[b].style && this.autoplayVimeoVideo(b)
                                        : a("body").on(
                                              "vimeoReady" + this.settings.namespace,
                                              function () {
                                                  g[b] && "muted" === g[b].style && this.autoplayVimeoVideo(b);
                                              }.bind(this)
                                          )),
                                    b &&
                                        "youtube" === k &&
                                        (c
                                            ? g[b] && "muted" === g[b].style && this.requestToPlayYoutubeVideo(b, !0)
                                            : a("body").on(
                                                  "youTubeReady" + this.settings.namespace,
                                                  function () {
                                                      g[b] && "muted" === g[b].style && this.requestToPlayYoutubeVideo(b, !0);
                                                  }.bind(this)
                                              )),
                                    b && g[b] && "muted" === g[b].style && "mp4" === k && this.playMp4Video(b),
                                    b && g[b] && "muted" != g[b].style && q(a("#" + b));
                            }
                            if (this.settings.zoom) {
                                var s = n.find("img");
                                this.destroyZoom(s);
                                var t = o.find("img").addClass("lazyload");
                                this.initZoom(t);
                            }
                        },
                        resizeSlides: function () {
                            this.settings.hasMultipleImages &&
                                (a(window).trigger("resize"),
                                setTimeout(
                                    function () {
                                        this.$mainSlider.slick("setPosition"), this.$thumbSlider.slick("setPosition");
                                    }.bind(this),
                                    500
                                ));
                        },
                        _slideIndex: function (a) {
                            return a.data("index");
                        },
                        initQtySelector: function () {
                            this.$container.find(".js-qty__wrapper").each(function () {
                                new theme.QtySelector(a(this), { namespace: ".product" });
                            });
                        },
                        initAjaxProductForm: function () {
                            "drawer" === theme.settings.cartType && new theme.AjaxProduct(a(this.selectors.formContainer));
                        },
                        openModalProduct: function () {
                            if (!this.settings.modalInit) {
                                var b = a(this.selectors.modalFormHolder),
                                    c = b.data("url");
                                (c += "?view=ajax"),
                                    b.load(
                                        c + " #AddToCartForm-" + this.sectionId,
                                        function () {
                                            this.formSetup(), Shopify.PaymentButton && Shopify.PaymentButton.init();
                                        }.bind(this)
                                    ),
                                    this.productSetup(),
                                    this.loadModalContent(),
                                    this.createImageCarousels(),
                                    (this.settings.modalInit = !0);
                            }
                            this.resizeSlides();
                        },
                        closeModalProduct: function () {
                            this.stopYoutubeVideo(), this.stopVimeoVideo(), this.stopMp4Video();
                        },
                        loadModalContent: function () {
                            var b = this.checkIfVideos();
                            b &&
                                b.indexOf("mp4") > -1 &&
                                this.$modal.find('.product__video[data-video-type="mp4"]').each(
                                    function (f, d) {
                                        var b = a(d),
                                            e = b.data("video-src"),
                                            c = document.createElement("source");
                                        c.setAttribute("src", e), b.append(c);
                                    }.bind(this)
                                );
                        },
                        onUnload: function () {
                            this.$container.off(this.settings.namespace), a("body").off(this.settings.namespace), this.destroyImageCarousels();
                        },
                    })),
                    b
                );
            })()),
            (theme.Collection = (function () {
                var c = !1,
                    d = { tags: ".tags", activeTag: "tag--active" };
                function b(b) {
                    (this.container = b), (this.sectionId = a(b).attr("data-section-id")), (this.namespace = ".collection-" + this.sectionId);
                    var c = a(b).find(".collection-hero");
                    c.length && theme.loadImageSection(c),
                        a(window).on(
                            "popstate",
                            function (a) {
                                a && this.getNewCollectionContent(location.href);
                            }.bind(this)
                        ),
                        this.init();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        init: function () {
                            (this.$container = a(this.container)), (this.sectionId = this.$container.attr("data-section-id")), this.sortBy(), this.sortTags(), this.initTagAjax();
                        },
                        initTagAjax: function () {
                            this.$container.on(
                                "click" + this.namespace,
                                ".tags a",
                                function (e) {
                                    var b = a(e.currentTarget);
                                    if (!b.hasClass("no-ajax") && (e.preventDefault(), !c)) {
                                        c = !0;
                                        var f = b.attr("href");
                                        a(d.tags)
                                            .find("." + d.activeTag)
                                            .removeClass(d.activeTag),
                                            b.parent().addClass(d.activeTag),
                                            history.pushState({}, "", f),
                                            a(".grid-product").addClass("unload"),
                                            this.getNewCollectionContent(f);
                                    }
                                }.bind(this)
                            );
                        },
                        getNewCollectionContent: function (b) {
                            (b += "?view=ajax"),
                                a("#CollectionAjaxResult").load(
                                    b + " #CollectionAjaxContent",
                                    function () {
                                        (c = !1), this.reInit();
                                    }.bind(this)
                                );
                        },
                        sortBy: function () {
                            var b = a("#SortBy");
                            b.length &&
                                b.on("change", function () {
                                    location.href = "?sort_by=" + a(this).val();
                                });
                        },
                        sortTags: function () {
                            var b = a("#SortTags");
                            b.length &&
                                b.on("change", function () {
                                    location.href = a(this).val();
                                });
                        },
                        reInit: function () {
                            for (var b = 0; b < sections.instances.length; b++) {
                                var c = sections.instances[b];
                                "collection-template" === c.type && c.forceReload();
                            }
                            AOS.refreshHard(),
                                theme.initQuickShop(!0),
                                a("body").hasClass("currencies-enabled") && theme.currencySwitcher.ajaxrefresh(),
                                window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
                                sections.register("product-template", theme.Product);
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            a(window).off(this.namespace), this.$container.off(this.namespace);
                        },
                    })),
                    b
                );
            })()),
            (theme.HeaderSection = (function () {
                var c = { drawer: "#NavDrawer", mobileSubNavToggle: ".mobile-nav__toggle-btn", hasSublist: ".mobile-nav__has-sublist" },
                    d = { navExpanded: "mobile-nav--expanded" };
                function b(d) {
                    var e = (this.$container = a(d));
                    this.sectionId = e.attr("data-section-id");
                    for (var b = 0; b < sections.instances.length; b++) {
                        var c = sections.instances[b];
                        "slideshow-section" === c.type && c.forceReload();
                    }
                    theme.currencySwitcher.init(), this.initDrawers(), theme.headerNav.init(), theme.announcementBar.init();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        initDrawers: function () {
                            (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")), "drawer" === theme.settings.cartType && (theme._CartDrawer = new theme.CartDrawer()), this.drawerMenuButtons();
                        },
                        drawerMenuButtons: function () {
                            a(c.drawer)
                                .find(".js-drawer-close")
                                .on("click", function (a) {
                                    a.preventDefault(), theme.NavDrawer.close();
                                });
                            var b = a(c.mobileSubNavToggle);
                            b.attr("aria-expanded", "false"),
                                b.each(function (d, c) {
                                    var b = a(c);
                                    b.attr("aria-controls", b.attr("data-aria-controls"));
                                }),
                                b.on("click", function () {
                                    var b = a(this),
                                        f = b.attr("aria-expanded"),
                                        e = !1;
                                    "true" === f ? b.attr("aria-expanded", "false") : (b.attr("aria-expanded", "true"), (e = !0)), b.closest(c.hasSublist).toggleClass(d.navExpanded, e);
                                });
                        },
                        onUnload: function () {
                            theme.NavDrawer.close(), theme.headerNav.unload(), theme.announcementBar.unload();
                        },
                    })),
                    b
                );
            })()),
            (theme.FeaturedContentSection = function () {
                a(".rte").find("a:not(:has(img))").addClass("text-link");
            }),
            (theme.slideshows = {}),
            (theme.SlideshowSection = (function () {
                function b(b) {
                    var c = (this.$container = a(b));
                    c.parent();
                    var e = c.attr("data-section-id");
                    this.slideshow = "#Slideshow-" + e;
                    var d = a(b).find(".hero");
                    d.length && theme.loadImageSection(d), this.init();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        init: function () {
                            var b = { arrows: a(this.slideshow).data("arrows"), dots: a(this.slideshow).data("dots") };
                            theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, b);
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            theme.slideshows[this.slideshow].destroy(), delete theme.slideshows[this.slideshow];
                        },
                        onSelect: function () {
                            a(this.slideshow).slick("slickPause");
                        },
                        onDeselect: function () {
                            a(this.slideshow).slick("slickPlay");
                        },
                        onBlockSelect: function (b) {
                            var c = a(this.slideshow),
                                d = a(".slideshow__slide--" + b.detail.blockId + ":not(.slick-cloned)"),
                                e = d.data("slick-index");
                            c.slick("slickGoTo", e).slick("slickPause");
                        },
                        onBlockDeselect: function () {
                            a(this.slideshow).slick("slickPlay");
                        },
                    })),
                    b
                );
            })()),
            (theme.VideoSection = (function () {
                var c,
                    d = [],
                    e = [],
                    f = {
                        width: 1280,
                        height: 720,
                        playerVars: { autohide: 0, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                        events: {
                            onReady: function (d) {
                                var c = a(d.target.a),
                                    b = c.attr("id");
                                (e[b] = d.target), e[b], o(c), e[b].mute(), c.attr("tabindex", "-1"), l(b), a(window).on("scroll." + b, { id: b }, a.throttle(150, l));
                            },
                            onStateChange: function (f) {
                                var b = a(f.target.a),
                                    c = b.attr("id"),
                                    g = e[c];
                                switch (f.data) {
                                    case -1:
                                        d[c].attemptedToPlay && (p(b), q(b));
                                        break;
                                    case 0:
                                        g.playVideo();
                                        break;
                                    case 1:
                                        p(b);
                                        break;
                                    case 3:
                                        d[c].attemptedToPlay = !0;
                                }
                            },
                        },
                    },
                    g = !1,
                    h = { byline: !1, title: !1, portrait: !1, loop: !0 },
                    i = { videoParent: ".video-parent-section" },
                    j = { loading: "loading", loaded: "loaded", interactable: "video-interactable" };
                function b(g) {
                    var h = (this.$container = a(g));
                    this.sectionId = h.attr("data-section-id");
                    var b = (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId);
                    this.namespace = "." + b;
                    var i = (this.vimeoPlayerId = "Vimeo-" + this.sectionId);
                    this.$vimeoTrigger = a("#VimeoTrigger-" + this.sectionId);
                    var c = "Mp4Video-" + this.sectionId,
                        d = a("#" + b),
                        e = a("#" + i),
                        f = a("#" + c);
                    (this.vimeoPlayer = []),
                        d.length && ((this.youtubeVideoId = d.data("video-id")), this.initYoutubeVideo()),
                        e.length && ((this.vimeoVideoId = e.data("video-id")), this.initVimeoVideo()),
                        f.length &&
                            (p(f),
                            k(c)
                                .then(function () {})
                                .catch(function (a) {
                                    q(f);
                                }));
                }
                function k(a) {
                    return document.querySelector("#" + a).play();
                }
                function l(c) {
                    var b;
                    (b = "string" == typeof c ? c : c.data.id), theme.isElementVisible(a("#" + b)) ? m(b) : n(b);
                }
                function m(a) {
                    e[a] && "function" == typeof e[a].playVideo && e[a].playVideo();
                }
                function n(a) {
                    e[a] && "function" == typeof e[a].pauseVideo && e[a].pauseVideo();
                }
                function o(a) {
                    a.closest(i.videoParent).addClass(j.loading);
                }
                function p(a) {
                    a.closest(i.videoParent).removeClass(j.loading).addClass(j.loaded);
                }
                function q(a) {
                    a.closest(i.videoParent).addClass(j.interactable);
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        initYoutubeVideo: function () {
                            (d[this.youtubePlayerId] = { id: this.youtubePlayerId, videoId: this.youtubeVideoId, type: "youtube", attemptedToPlay: !1 }),
                                c ? this.loadYoutubeVideo() : (window.loadYouTube(), a("body").on("youTubeReady" + this.namespace, this.loadYoutubeVideo.bind(this)));
                        },
                        loadYoutubeVideo: function () {
                            var b = a.extend({}, f, d[this.youtubePlayerId]);
                            (b.playerVars.controls = 0), (e[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, b)), (c = !0);
                        },
                        initVimeoVideo: function () {
                            d[this.vimeoPlayerId] = { divId: this.vimeoPlayerId, id: this.vimeoVideoId, type: "vimeo" };
                            var b = a("#" + this.vimeoPlayerId);
                            o(b),
                                this.$vimeoTrigger.on(
                                    "click",
                                    +this.namespace,
                                    function (a) {
                                        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                                    }.bind(this)
                                ),
                                g ? this.loadVimeoVideo() : (window.loadVimeo(), a("body").on("vimeoReady" + this.namespace, this.loadVimeoVideo.bind(this)));
                        },
                        loadVimeoVideo: function () {
                            var b = a.extend({}, h, d[this.vimeoPlayerId]);
                            if (((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(d[this.vimeoPlayerId].divId, b)), (g = !0), theme.config.bpSmall)) {
                                var c = a("#" + this.vimeoPlayerId);
                                p(c);
                            } else this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                        },
                        requestToPlayVimeoVideo: function (b) {
                            if (!g) {
                                a("body").on(
                                    "vimeoReady" + this.namespace,
                                    function () {
                                        this.playVimeoVideo(b);
                                    }.bind(this)
                                );
                                return;
                            }
                            this.playVimeoVideo(b);
                        },
                        playVimeoVideo: function (b) {
                            this.vimeoPlayer[b].play(), this.vimeoPlayer[b].setVolume(0);
                            var c = a("#" + b);
                            p(c);
                        },
                        onUnload: function (b) {
                            e["YouTubeVideo-" + b.target.id.replace("shopify-section-", "")].destroy(), a(window).off("scroll" + this.namespace), a("body").off("vimeoReady" + this.namespace);
                        },
                    })),
                    b
                );
            })()),
            (theme.Testimonials = (function () {
                var c = 0,
                    d = { accessibility: !0, arrows: !1, dots: !0, autoplay: !1, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
                function b(e) {
                    var f = (this.$container = a(e)).attr("data-section-id");
                    this.wrapper = ".testimonials-wrapper";
                    var b = a((this.slider = "#Testimonials-" + f));
                    this.sliderActive = !1;
                    var g = a.extend({}, d, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: !0 });
                    (c = b.data("count")) < d.slidesToShow && ((d.slidesToShow = c), (d.slidesToScroll = c)),
                        b.on("init", this.a11y.bind(this)),
                        theme.config.bpSmall ? this.init(b, g) : this.init(b, d),
                        a("body").on(
                            "matchSmall",
                            function () {
                                this.init(b, g);
                            }.bind(this)
                        ),
                        a("body").on(
                            "matchLarge",
                            function () {
                                this.init(b, d);
                            }.bind(this)
                        );
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        onUnload: function () {
                            a(this.slider, this.wrapper).slick("unslick");
                        },
                        onBlockSelect: function (b) {
                            var c = a(".testimonials-slide--" + b.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                            a(this.slider, this.wrapper).slick("slickGoTo", c);
                        },
                        init: function (a, b) {
                            this.sliderActive && (a.slick("unslick"), (this.sliderActive = !1)), a.slick(b), (this.sliderActive = !0), AOS && AOS.refresh();
                        },
                        a11y: function (e, c) {
                            var d = c.$list,
                                b = a(this.wrapper, this.$container);
                            d.removeAttr("aria-live"),
                                b.on("focusin", function (a) {
                                    b.has(a.target).length && d.attr("aria-live", "polite");
                                }),
                                b.on("focusout", function (a) {
                                    b.has(a.target).length && d.removeAttr("aria-live");
                                });
                        },
                    })),
                    b
                );
            })()),
            (theme.Instagram = (function () {
                var c = !1;
                function b(c) {
                    var b = (this.$container = a(c)).attr("data-section-id");
                    (this.namespace = ".instagram-" + b), (this.$target = a("#Instafeed-" + b)), this.$target.length && (this.checkVisibility(), a(window).on("scroll" + this.namespace, a.throttle(100, this.checkVisibility.bind(this))));
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        checkVisibility: function () {
                            if (c) {
                                a(window).off("scroll" + this.namespace);
                                return;
                            }
                            theme.isElementVisible(this.$container) && this.init();
                        },
                        init: function () {
                            c = !0;
                            var a = this.$target.data("user-id"),
                                b = this.$target.data("client-id"),
                                d = parseInt(this.$target.data("count"));
                            (this.feed = new Instafeed({
                                target: this.$target[0],
                                accessToken: b,
                                get: "user",
                                userId: a,
                                limit: d + 2,
                                template:
                                    '<div class="grid__item small--one-half medium-up--one-fifth"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
                                resolution: "standard_resolution",
                            })).run(),
                                this.$target.addClass("instagram-holder--active");
                        },
                    })),
                    b
                );
            })()),
            (theme.NewsletterPopup = (function () {
                function b(d) {
                    var b = (this.$container = a(d)),
                        c = b.attr("data-section-id");
                    if (((this.cookieName = "newsletter-" + c), b.length)) {
                        if (
                            ((this.data = { secondsBeforeShow: b.data("delay-seconds"), daysBeforeReappear: b.data("delay-days"), cookie: Cookies.get(this.cookieName), testMode: b.data("test-mode") }),
                            (this.modal = new theme.Modals("NewsletterPopup-" + c, "newsletter-popup-modal")),
                            (b.find(".errors").length || b.find(".note--success").length) && this.modal.open(),
                            b.find(".note--success").length)
                        ) {
                            this.closePopup(!0);
                            return;
                        }
                        a("body").on("modalClose." + b.attr("id"), this.closePopup.bind(this)), (!this.data.cookie || this.data.testMode) && this.initPopupDelay();
                    }
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        initPopupDelay: function () {
                            setTimeout(
                                function () {
                                    this.modal.open();
                                }.bind(this),
                                1e3 * this.data.secondsBeforeShow
                            );
                        },
                        closePopup: function (a) {
                            if (this.data.testMode) {
                                Cookies.remove(this.cookieName, { path: "/" });
                                return;
                            }
                            var b = a ? 200 : this.data.daysBeforeReappear;
                            Cookies.set(this.cookieName, "opened", { path: "/", expires: b });
                        },
                        onLoad: function () {
                            this.modal.open();
                        },
                        onSelect: function () {
                            this.modal.open();
                        },
                        onDeselect: function () {
                            this.modal.close();
                        },
                        onUnload: function () {},
                    })),
                    b
                );
            })()),
            (theme.FadingImages = (function () {
                var c = { activeImage: "active-image", finishedImage: "finished-image", activeTitles: "active-titles", finishedTitles: "finished-titles", compensation: "compensation" };
                function b(c) {
                    var b = (this.$container = a(c)),
                        d = b.attr("data-section-id");
                    if (((this.namespace = ".fading-images-" + d), b.length)) {
                        var e = b.find(".fading-images");
                        theme.loadImageSection(e),
                            (this.data = { isInit: !1, interval: b.data("interval"), block_count: b.data("count"), finish_interval: 1e3, timer_offset: 400, active_image: 1, active_title: 1, removed_compensation: !1 }),
                            (this.selectors = { $allTitles: b.find(".fading-images-overlay__titles") }),
                            this.checkVisibility(),
                            a(window).on("scroll" + this.namespace, a.throttle(100, this.checkVisibility.bind(this)));
                    }
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        checkVisibility: function () {
                            if (this.data.isInit) {
                                a(window).off("scroll" + this.namespace);
                                return;
                            }
                            theme.isElementVisible(this.$container) && (this.startImages(), this.startTitles(), (this.data.isInit = !0));
                        },
                        nextImage: function () {
                            var a = this.$container;
                            this.data.removed_compensation || (a.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").removeClass(c.compensation), (this.data.removed_compensation = !0)),
                                a
                                    .find(".fading-images__item[data-slide-index=" + this.data.active_image + "]")
                                    .removeClass(c.activeImage)
                                    .addClass(c.finishedImage);
                            var b = this.data.active_image;
                            window.setTimeout(function () {
                                a.find(".fading-images__item[data-slide-index=" + b + "]").removeClass(c.finishedImage);
                            }, this.data.finish_interval),
                                this.data.active_image++,
                                this.data.active_image > this.data.block_count && (this.data.active_image = 1),
                                a.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").addClass(c.activeImage);
                        },
                        nextTitle: function () {
                            var a = this.$container,
                                b = this.selectors.$allTitles;
                            this.selectors.$allTitles.removeClass(c.activeTitles).addClass(c.finishedTitles), this.data.active_title++, this.data.active_title > this.data.block_count && (this.data.active_title = 1);
                            var d = this.data.active_title;
                            window.setTimeout(function () {
                                var e = a.find(".fading-images__item[data-slide-index=" + d + "]").attr("data-slide-title1"),
                                    f = a.find(".fading-images__item[data-slide-index=" + d + "]").attr("data-slide-title2");
                                a.find(".fading-images-overlay__title--1").text(e), a.find(".fading-images-overlay__title--2").text(f), b.removeClass(c.finishedTitles).addClass(c.activeTitles);
                            }, this.data.finish_interval - 200);
                        },
                        startImages: function () {
                            this.$container
                                .find(".fading-images__item[data-slide-index=" + this.data.active_image + "]")
                                .addClass(c.activeImage)
                                .addClass(c.compensation);
                            var a = this;
                            window.setTimeout(function () {
                                window.setInterval(a.nextImage.bind(a), a.data.interval);
                            }, this.data.timer_offset);
                        },
                        startTitles: function () {
                            var a = this.$container,
                                b = this.selectors.$allTitles,
                                d = this.data.active_title;
                            window.setTimeout(function () {
                                var e = a.find(".fading-images__item[data-slide-index=" + d + "]").attr("data-slide-title1"),
                                    f = a.find(".fading-images__item[data-slide-index=" + d + "]").attr("data-slide-title2");
                                a.find(".fading-images-overlay__title--1").text(e), a.find(".fading-images-overlay__title--2").text(f), b.addClass(c.activeTitles);
                            }, 750),
                                window.setInterval(this.nextTitle.bind(this), this.data.interval);
                        },
                        onLoad: function () {},
                        onSelect: function () {},
                        onDeselect: function () {},
                        onUnload: function () {},
                    })),
                    b
                );
            })()),
            (theme.Maps = (function () {
                var c = { zoom: 14 },
                    d = null,
                    e = [],
                    f = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
                    g = { section: '[data-section-type="map"]', map: "[data-map]", mapOverlay: "[data-map-overlay]" },
                    h = { mapError: "map-section--load-error", errorMsg: "map-section__error errors text-center" };
                function b(b) {
                    (this.$container = a(b)),
                        (this.sectionId = this.$container.attr("data-section-id")),
                        (this.namespace = ".map-" + this.sectionId),
                        (this.$map = this.$container.find(g.map)),
                        (this.key = this.$map.data("api-key")),
                        this.key && (this.checkVisibility(), a(window).on("scroll" + this.namespace, a.throttle(50, this.checkVisibility.bind(this))));
                }
                return (
                    (window.gm_authFailure = function () {
                        Shopify.designMode && (a(g.section).addClass(h.mapError), a(g.map).remove(), a(g.mapOverlay).after('<div class="' + h.errorMsg + '">' + theme.strings.authError + "</div>"));
                    }),
                    (b.prototype = a.extend({}, b.prototype, {
                        prepMapApi: function () {
                            "loaded" === d
                                ? this.createMap()
                                : (e.push(this),
                                  "loading" !== d &&
                                      ((d = "loading"),
                                      void 0 === window.google &&
                                          a.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
                                              (d = "loaded"),
                                                  a.each(e, function (b, a) {
                                                      a.createMap();
                                                  });
                                          })));
                        },
                        createMap: function () {
                            var b,
                                d,
                                e,
                                g,
                                i = this.$map;
                            return ((b = i),
                            (d = a.Deferred()),
                            (e = new google.maps.Geocoder()),
                            (g = b.data("address-setting")),
                            e.geocode({ address: g }, function (b, a) {
                                a !== google.maps.GeocoderStatus.OK && d.reject(a), d.resolve(b);
                            }),
                            d)
                                .then(
                                    function (d) {
                                        var e = { zoom: c.zoom, backgroundColor: "none", center: d[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                            b = (this.map = new google.maps.Map(i[0], e)),
                                            f = (this.center = b.getCenter());
                                        new google.maps.Marker({ map: b, position: b.getCenter() }),
                                            google.maps.event.addDomListener(
                                                window,
                                                "resize",
                                                a.debounce(250, function () {
                                                    google.maps.event.trigger(b, "resize"), b.setCenter(f), i.removeAttr("style");
                                                })
                                            );
                                    }.bind(this)
                                )
                                .fail(function () {
                                    var a;
                                    switch (status) {
                                        case "ZERO_RESULTS":
                                            a = f.addressNoResults;
                                            break;
                                        case "OVER_QUERY_LIMIT":
                                            a = f.addressQueryLimit;
                                            break;
                                        case "REQUEST_DENIED":
                                            a = f.authError;
                                            break;
                                        default:
                                            a = f.addressError;
                                    }
                                    Shopify.designMode &&
                                        i
                                            .parent()
                                            .addClass(h.mapError)
                                            .html('<div class="' + h.errorMsg + '">' + a + "</div>");
                                });
                        },
                        checkVisibility: function () {
                            theme.isElementVisible(this.$container, 600) && (this.prepMapApi(), a(window).off(this.namespace));
                        },
                        onUnload: function () {
                            0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize");
                        },
                    })),
                    b
                );
            })()),
            (theme.Blog = (function () {
                function b(a) {
                    this.tagFilters();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        tagFilters: function () {
                            var b = a("#BlogTagFilter");
                            b.length &&
                                b.on("change", function () {
                                    location.href = a(this).val();
                                });
                        },
                        onUnload: function () {},
                    })),
                    b
                );
            })()),
            (theme.Photoswipe = (function () {
                var c = { photoswipeImg: ".photoswipe__image" };
                function b(d) {
                    var b = (this.$container = a(d));
                    b.attr("data-section-id"), (this.namespace = ".photoswipe-" + this.sectionId), (this.$images = b.find(c.photoswipeImg)), this.gallery, b.length && this.init();
                }
                return (
                    (b.prototype = a.extend({}, b.prototype, {
                        init: function () {
                            var b = [];
                            this.$images.each(function () {
                                var c = { msrc: a(this).prop("currentSrc") || a(this).prop("src"), src: a(this).data("photoswipe-src"), w: a(this).data("photoswipe-width"), h: a(this).data("photoswipe-height"), el: a(this)[0] };
                                b.push(c);
                            }),
                                this.$images.on(
                                    "click" + this.namespace,
                                    function (c) {
                                        (index = a(c.currentTarget).data("index")), this.initGallery(b, index);
                                    }.bind(this)
                                );
                        },
                        initGallery: function (a, b) {
                            var c = document.querySelectorAll(".pswp")[0];
                            (this.gallery = new PhotoSwipe(c, PhotoSwipeUI_Default, a, {
                                history: !1,
                                index: b - 1,
                                getThumbBoundsFn: function (c) {
                                    var d = window.pageYOffset || document.documentElement.scrollTop,
                                        b = a[c].el.getBoundingClientRect();
                                    return { x: b.left, y: b.top + d, w: b.width };
                                },
                            })),
                                this.gallery.init();
                        },
                        onUnload: function () {
                            this.$images.off("click" + this.namespace), this.gallery.destroy();
                        },
                    })),
                    b
                );
            })()),
            (theme.bp = {}),
            (theme.bp.smallUp = 590),
            (theme.bp.small = theme.bp.smallUp - 1),
            (theme.config = {
                bpSmall: !1,
                hasSessionStorage: !0,
                mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
                mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
                youTubeReady: !1,
                vimeoReady: !1,
                vimeoLoading: !1,
                isTouch: !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch)) || !!window.navigator.maxTouchPoints || !!window.navigator.msMaxTouchPoints,
            }),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), a("body").trigger("youTubeReady");
            }),
            (window.loadYouTube = function () {
                if (!theme.config.youtubeReady) {
                    var a = document.createElement("script");
                    a.src = "https://www.youtube.com/iframe_api";
                    var b = document.getElementsByTagName("script")[0];
                    b.parentNode.insertBefore(a, b);
                }
            }),
            (window.loadVimeo = function () {
                if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
                    theme.config.vimeoLoading = !0;
                    var b = document.createElement("script");
                    b.src = "https://player.vimeo.com/api/player.js";
                    var e,
                        f,
                        c,
                        d = document.getElementsByTagName("script")[0];
                    d.parentNode.insertBefore(b, d),
                        ((c = a.Deferred()),
                        (e = setInterval(function () {
                            Vimeo && (clearInterval(e), clearTimeout(f), c.resolve());
                        }, 500)),
                        (f = setTimeout(function () {
                            clearInterval(e), c.reject();
                        }, 4e3)),
                        c)
                            .then(function () {
                                (theme.config.vimeoReady = !0), (theme.config.vimeoLoading = !1), a("body").trigger("vimeoReady");
                            })
                            .fail(function () {});
                }
            }),
            (theme.init = function () {
                theme.setGlobals(),
                    theme.pageTransitions(),
                    theme.initQuickShop(),
                    theme.videoModal(),
                    theme.bundlesPage(),
                    theme.articleImages.init(),
                    theme.customerTemplates.init(),
                    theme.collapsibles.init(),
                    slate.rte.init(),
                    AOS.init({ easing: "ease-out-quad", once: !0, offset: 60, disableMutationObserver: !0 }),
                    a(document.documentElement).on("keyup.tab", function (b) {
                        9 === b.keyCode && (a(document.documentElement).addClass("tab-outline"), a(document.documentElement).off("keyup.tab"));
                    });
            }),
            (theme.bundlesPage = function () {
                if (a("#bundle-builder-app--bundle--root").length) {
                    function b() {
                        a("body").on("click", ".bundle-builder-app--bundle--product-add--wrapper", function (b) {
                            setTimeout(function () {
                                let b = a(".bundle-builder-app--bundle--summary");
                                a(".bundle-builder-app--bundle--add-to-cart-button").prop("disabled") ? b.hide() : b.show(), 0 == a(".bundle-extra-cart-button").length && d(), c();
                            }, 300);
                        });
                    }
                    function c() {
                        let b = '<a class="bundle-builder-nav-prev" href="/pages/create-your-bundle">Previous</a>',
                            c = a(".bundle-builder-app--bundle--nav-buttons");
                        a(".bundle-builder-app--bundle--nav-buttons--prev").length ? a(".bundle-builder-nav-prev").remove() : 0 == a(".bundle-builder-nav-prev").length && c.append(b);
                    }
                    function d() {
                        let d = !1,
                            e = window.handle,
                            c = !1;
                        for (let b = 0; b < window.bundles.length; b++)
                            if (e === window.bundles[b].bundleID) {
                                (c = window.bundles[b].variantID), (d = !0);
                                break;
                            }
                        if (d && c) {
                            let f = a(".bundle-builder-app--button-container"),
                                g = a(".bundle-builder-app--bundle--add-to-cart-button"),
                                h = `<a class="btn bundle-extra-cart-button" data-bundle-variant-id="${c}" tabindex="0">Add bundle to cart</a>`;
                            f.append(h),
                                g.addClass("visually-hidden"),
                                a(".bundle-extra-cart-button").one("click", function (b) {
                                    a.ajax({
                                        type: "POST",
                                        url: "/cart/add.js",
                                        data: { quantity: 1, id: a(this).attr("data-bundle-variant-id") },
                                        dataType: "json",
                                        success: function (a) {
                                            console.log("added to cart, submitting form"), g.trigger("click");
                                        },
                                    });
                                });
                        }
                    }
                    setTimeout(function () {
                        let d = "Create Your Bundle",
                            e = '<li class="bundle-builder-app--bundle--section-breadcrumb" data-step="1"><a href="/pages/create-your-bundle">Choose Your Size</a></li>';
                        a(".bundle-builder-app--bundle--name").html(d),
                            a(".bundle-builder-app--bundle--section-breadcrumb").each(function (c) {
                                let b = String(parseInt(a(this).data("step")) + 1);
                                a(this).addClass("change").attr("data-content", b).attr("data-step", b);
                            }),
                            a(".bundle-builder-app--bundle--section-breadcrumbs").prepend(e),
                            a(".bundle-builder-app--bundle--section-breadcrumbs, .bundle-builder-app--bundle--section-breadcrumbs--disabled, h1.bundle-builder-app--bundle--name").css({ cssText: "opacity: 1 !important" }),
                            a(".bundle-builder-app--bundle--nav-buttons").observe("childlist subtree", function (a) {
                                b(), c();
                            }),
                            b(),
                            c();
                    }, 1e3);
                }
            }),
            (theme.setGlobals = function () {
                (theme.config.hasSessionStorage = theme.isSessionStorageSupported()),
                    theme.config.isTouch && a("body").addClass("supports-touch"),
                    enquire.register(theme.config.mediaQuerySmall, {
                        match: function () {
                            (theme.config.bpSmall = !0), a("body").trigger("matchSmall");
                        },
                        unmatch: function () {
                            (theme.config.bpSmall = !1), a("body").trigger("unmatchSmall");
                        },
                    }),
                    enquire.register(theme.config.mediaQueryMediumUp, {
                        match: function () {
                            a("body").trigger("matchLarge");
                        },
                        unmatch: function () {
                            a("body").trigger("unmatchLarge");
                        },
                    });
            }),
            (theme.loadImageSection = function (a) {
                function b() {
                    a.removeClass("loading loading--delayed").addClass("loaded");
                }
                function c() {
                    return a.find(".lazyloaded").length;
                }
                if (a.find("svg").length || c() > 0) {
                    b();
                    return;
                }
                var d = setInterval(function () {
                    c() > 0 && (clearInterval(d), b());
                }, 80);
            }),
            (theme.isSessionStorageSupported = function () {
                if (window.self !== window.top) return !1;
                var a = "test",
                    b = window.sessionStorage;
                try {
                    return b.setItem(a, "1"), b.removeItem(a), !0;
                } catch (c) {
                    return !1;
                }
            }),
            (theme.isElementVisible = function (c, b) {
                var a = c[0].getBoundingClientRect(),
                    d = window.innerHeight || document.documentElement.clientHeight;
                return (b = b || 0), a.bottom >= 0 && a.right >= 0 && a.top <= d + b && a.left <= (window.innerWidth || document.documentElement.clientWidth);
            }),
            (theme.pageTransitions = function () {
                !0 == a("body").data("transitions") &&
                    (navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) &&
                        a("a").on("click", function () {
                            window.setTimeout(function () {
                                a("body").removeClass("unloading");
                            }, 1200);
                        }),
                    a('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function () {
                        a(this).addClass("js-no-transition");
                    }),
                    a("a:not(.js-no-transition)").bind("click", function (b) {
                        if (b.metaKey) return !0;
                        b.preventDefault(), a("body").addClass("unloading");
                        var c = a(this).attr("href");
                        window.setTimeout(function () {
                            location.href = c;
                        }, 50);
                    }),
                    a("a.mobile-nav__link").bind("click", function () {
                        theme.NavDrawer.close();
                    }));
            }),
            (window.onpageshow = function (b) {
                b.persisted && a("body").removeClass("unloading");
            }),
            a(document).ready(function () {
                theme.init(),
                    (window.sections = new theme.Sections()),
                    sections.register("header-section", theme.HeaderSection),
                    sections.register("slideshow-section", theme.SlideshowSection),
                    sections.register("video-section", theme.VideoSection),
                    sections.register("product", theme.Product),
                    sections.register("product-template", theme.Product),
                    sections.register("collection-template", theme.Collection),
                    sections.register("featured-content-section", theme.FeaturedContentSection),
                    sections.register("testimonials", theme.Testimonials),
                    sections.register("instagram", theme.Instagram),
                    sections.register("newsletter-popup", theme.NewsletterPopup),
                    sections.register("fading-images", theme.FadingImages),
                    sections.register("map", theme.Maps),
                    sections.register("blog", theme.Blog),
                    sections.register("photoswipe", theme.Photoswipe);
            });
    })(theme.jQuery);